// Generated by apps/site/scripts/generate-clovis-docs.mjs. Do not edit manually.

export const clovisDocs = {
  "source": {
    "name": "clovis",
    "version": "1.3.0",
    "description": "Local-first bookkeeping CLI, MCP server, and SQLite ledger engine",
    "license": "AGPL-3.0-or-later",
    "node": ">=26.3.0",
    "bins": {
      "clovis": "dist/cli/main.js",
      "clovis-mcp": "dist/mcp/main.js"
    },
    "exports": {
      ".": {
        "types": "./dist/index.d.ts",
        "import": "./dist/index.js"
      },
      "./core": {
        "types": "./dist/core/index.d.ts",
        "import": "./dist/core/index.js"
      },
      "./app": {
        "types": "./dist/app/index.d.ts",
        "import": "./dist/app/index.js"
      },
      "./mcp": {
        "types": "./dist/mcp/index.d.ts",
        "import": "./dist/mcp/index.js"
      }
    }
  },
  "stats": {
    "tools": 146,
    "readOnlyTools": 75,
    "destructiveTools": 21,
    "dryRunTools": 71,
    "defaultDryRunTools": 18,
    "cliCommands": 33
  },
  "installCommand": "npm install -g clovis",
  "mcpCommand": "CLOVIS_DB=./ledger.db clovis-mcp",
  "agentFiles": [
    {
      "label": "llms.txt",
      "href": "/llms.txt",
      "description": "Short entrypoint for coding assistants and crawlers."
    },
    {
      "label": "Agent guide",
      "href": "/docs/agent-guide.md",
      "description": "Workflow, MCP setup, and safety rules in Markdown."
    },
    {
      "label": "MCP manifest",
      "href": "/docs/mcp-tools.json",
      "description": "Server resources, tool signatures, and safety hints."
    },
    {
      "label": "Tool catalog",
      "href": "/docs/clovis-tools.json",
      "description": "Complete shared CLI, API, and MCP tool surface."
    },
    {
      "label": "CLI manifest",
      "href": "/docs/clovis-cli.json",
      "description": "Command tree and captured help output."
    },
    {
      "label": "SQLite schema",
      "href": "/docs/clovis-schema.json",
      "description": "Tables, fields, indexes, triggers, relationships, and canonical DDL."
    },
    {
      "label": "Changelog",
      "href": "/docs/clovis-changelog.json",
      "description": "Machine-readable release history generated from the package changelog."
    }
  ],
  "cliCommands": [
    {
      "command": "clovis",
      "slug": "clovis",
      "path": [],
      "usage": "Usage: clovis [options] [command]",
      "description": "Local-first bookkeeping CLI",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--format <format>",
            "description": "Output format: json or table",
            "raw": "--format <format>      Output format: json or table"
          },
          {
            "term": "--db <path>",
            "description": "Path to ledger database (default: \"./ledger.db\")",
            "raw": "--db <path>            Path to ledger database (default: \"./ledger.db\")"
          },
          {
            "term": "-V, --version",
            "description": "output the version number",
            "raw": "-V, --version          output the version number"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help             display help for command"
          }
        ],
        "commands": [
          {
            "term": "tools",
            "description": "List every public app tool",
            "raw": "tools                  List every public app tool"
          },
          {
            "term": "doctor [options]",
            "description": "Run local diagnostics",
            "raw": "doctor [options]       Run local diagnostics"
          },
          {
            "term": "tool [options] <name>",
            "description": "Run any public app tool by name",
            "raw": "tool [options] <name>  Run any public app tool by name"
          },
          {
            "term": "account",
            "description": "Manage accounts",
            "raw": "account                Manage accounts"
          },
          {
            "term": "txn",
            "description": "Manage transactions",
            "raw": "txn                    Manage transactions"
          },
          {
            "term": "balance <account_id>",
            "description": "Show posted balances for an account",
            "raw": "balance <account_id>   Show posted balances for an account"
          },
          {
            "term": "init [options]",
            "description": "Initialize a ledger with default accounts",
            "raw": "init [options]         Initialize a ledger with default accounts"
          },
          {
            "term": "export [options]",
            "description": "Export transactions as CSV",
            "raw": "export [options]       Export transactions as CSV"
          },
          {
            "term": "import [options]",
            "description": "Import a CSV statement into an account",
            "raw": "import [options]       Import a CSV statement into an account"
          },
          {
            "term": "report",
            "description": "Run accounting reports",
            "raw": "report                 Run accounting reports"
          },
          {
            "term": "help [command]",
            "description": "display help for command",
            "raw": "help [command]         display help for command"
          }
        ],
        "examples": [
          "  clovis init --currency CAD",
          "  clovis account balances --type asset",
          "  clovis txn add --date 2026-06-01 --amount 100 --from <equity-id> --to <checking-id> --status posted",
          "  clovis report balance-sheet --quote CAD",
          "  clovis tool account_balances --json '{\"account_type\":\"asset\"}'"
        ],
        "notes": [
          "Default ledger: /home/clovis/.clovis/clovis.db",
          "Use --db or CLOVIS_DB to select another ledger.",
          "Use --format json for stable machine-readable output.",
          "Clovis does not infer report currency; report commands require --quote."
        ]
      },
      "help": "Usage: clovis [options] [command]\n\nLocal-first bookkeeping CLI\n\nOptions:\n  --format <format>      Output format: json or table\n  --db <path>            Path to ledger database (default: \"./ledger.db\")\n  -V, --version          output the version number\n  -h, --help             display help for command\n\nCommands:\n  tools                  List every public app tool\n  doctor [options]       Run local diagnostics\n  tool [options] <name>  Run any public app tool by name\n  account                Manage accounts\n  txn                    Manage transactions\n  balance <account_id>   Show posted balances for an account\n  init [options]         Initialize a ledger with default accounts\n  export [options]       Export transactions as CSV\n  import [options]       Import a CSV statement into an account\n  report                 Run accounting reports\n  help [command]         display help for command\n\nExamples:\n  clovis init --currency CAD\n  clovis account balances --type asset\n  clovis txn add --date 2026-06-01 --amount 100 --from <equity-id> --to <checking-id> --status posted\n  clovis report balance-sheet --quote CAD\n  clovis tool account_balances --json '{\"account_type\":\"asset\"}'\n\nNotes:\n  Default ledger: /home/clovis/.clovis/clovis.db\n  Use --db or CLOVIS_DB to select another ledger.\n  Use --format json for stable machine-readable output.\n  Clovis does not infer report currency; report commands require --quote."
    },
    {
      "command": "clovis tools",
      "slug": "tools",
      "path": [
        "tools"
      ],
      "usage": "Usage: clovis tools [options]",
      "description": "List every public app tool",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis --format json tools",
          "  clovis tools | grep account_balances"
        ],
        "notes": []
      },
      "help": "Usage: clovis tools [options]\n\nList every public app tool\n\nOptions:\n  -h, --help  display help for command\n\nExamples:\n  clovis --format json tools\n  clovis tools | grep account_balances"
    },
    {
      "command": "clovis doctor",
      "slug": "doctor",
      "path": [
        "doctor"
      ],
      "usage": "Usage: clovis doctor [options]",
      "description": "Run local diagnostics",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--read-only-tools",
            "description": "Exercise read-only tool paths",
            "raw": "--read-only-tools  Exercise read-only tool paths"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset id or symbol for report checks",
            "raw": "--quote <asset>    Quote asset id or symbol for report checks"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis doctor --read-only-tools --quote CAD"
        ],
        "notes": [
          "The read-only suite does not mutate the ledger."
        ]
      },
      "help": "Usage: clovis doctor [options]\n\nRun local diagnostics\n\nOptions:\n  --read-only-tools  Exercise read-only tool paths\n  --quote <asset>    Quote asset id or symbol for report checks\n  -h, --help         display help for command\n\nExamples:\n  clovis doctor --read-only-tools --quote CAD\n\nNotes:\n  The read-only suite does not mutate the ledger."
    },
    {
      "command": "clovis tool",
      "slug": "tool",
      "path": [
        "tool"
      ],
      "usage": "Usage: clovis tool [options] <name>",
      "description": "Run any public app tool by name",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--json <json>",
            "description": "Tool args as a JSON object",
            "raw": "--json <json>  Tool args as a JSON object"
          },
          {
            "term": "--stdin",
            "description": "Read tool args as a JSON object from stdin",
            "raw": "--stdin        Read tool args as a JSON object from stdin"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help     display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis tool account_balances --json '{\"account_type\":\"asset\"}'",
          "  clovis tool import_transactions --stdin < args.json",
          "  clovis tool backup_now",
          "  clovis tool void_by_filter --json '{\"status\":\"planned\",\"date_to\":\"2026-05-31\"}'",
          "  clovis tool void_by_filter --json '{\"status\":\"planned\",\"date_to\":\"2026-05-31\",\"dry_run\":false}'"
        ],
        "notes": [
          "Run `clovis tools` to list tool names and signatures.",
          "Tool args must be a JSON object.",
          "File tools use ordinary filesystem permissions.",
          "Bulk mutation tools default to dry_run; pass dry_run:false to apply."
        ]
      },
      "help": "Usage: clovis tool [options] <name>\n\nRun any public app tool by name\n\nOptions:\n  --json <json>  Tool args as a JSON object\n  --stdin        Read tool args as a JSON object from stdin\n  -h, --help     display help for command\n\nExamples:\n  clovis tool account_balances --json '{\"account_type\":\"asset\"}'\n  clovis tool import_transactions --stdin < args.json\n  clovis tool backup_now\n  clovis tool void_by_filter --json '{\"status\":\"planned\",\"date_to\":\"2026-05-31\"}'\n  clovis tool void_by_filter --json '{\"status\":\"planned\",\"date_to\":\"2026-05-31\",\"dry_run\":false}'\n\nNotes:\n  Run `clovis tools` to list tool names and signatures.\n  Tool args must be a JSON object.\n  File tools use ordinary filesystem permissions.\n  Bulk mutation tools default to dry_run; pass dry_run:false to apply."
    },
    {
      "command": "clovis account",
      "slug": "account",
      "path": [
        "account"
      ],
      "usage": "Usage: clovis account [options] [command]",
      "description": "Manage accounts",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help             display help for command"
          }
        ],
        "commands": [
          {
            "term": "add [options]",
            "description": "Create an account",
            "raw": "add [options]          Create an account"
          },
          {
            "term": "balances [options]",
            "description": "List posted, pending, and current balances by account and asset",
            "raw": "balances [options]     List posted, pending, and current balances by account and asset"
          },
          {
            "term": "list [options]",
            "description": "List accounts",
            "raw": "list [options]         List accounts"
          },
          {
            "term": "get <id>",
            "description": "Show one account",
            "raw": "get <id>               Show one account"
          },
          {
            "term": "update [options] <id>",
            "description": "Update an account",
            "raw": "update [options] <id>  Update an account"
          },
          {
            "term": "delete <id>",
            "description": "Delete an unused account",
            "raw": "delete <id>            Delete an unused account"
          },
          {
            "term": "help [command]",
            "description": "display help for command",
            "raw": "help [command]         display help for command"
          }
        ],
        "examples": [
          "  clovis account list",
          "  clovis account balances --type asset",
          "  clovis account add --name \"Cash\" --type asset"
        ],
        "notes": []
      },
      "help": "Usage: clovis account [options] [command]\n\nManage accounts\n\nOptions:\n  -h, --help             display help for command\n\nCommands:\n  add [options]          Create an account\n  balances [options]     List posted, pending, and current balances by account\n                         and asset\n  list [options]         List accounts\n  get <id>               Show one account\n  update [options] <id>  Update an account\n  delete <id>            Delete an unused account\n  help [command]         display help for command\n\nExamples:\n  clovis account list\n  clovis account balances --type asset\n  clovis account add --name \"Cash\" --type asset"
    },
    {
      "command": "clovis account add",
      "slug": "account-add",
      "path": [
        "account",
        "add"
      ],
      "usage": "Usage: clovis account add [options]",
      "description": "Create an account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--name <name>",
            "description": "Account name",
            "raw": "--name <name>  Account name"
          },
          {
            "term": "--type <type>",
            "description": "Account type: asset, liability, equity, income, or expense",
            "raw": "--type <type>  Account type: asset, liability, equity, income, or expense"
          },
          {
            "term": "--code <code>",
            "description": "Optional account code (default: \"\")",
            "raw": "--code <code>  Optional account code (default: \"\")"
          },
          {
            "term": "--parent <id>",
            "description": "Parent account id",
            "raw": "--parent <id>  Parent account id"
          },
          {
            "term": "--color <hex>",
            "description": "Account color (default: \"#888888\")",
            "raw": "--color <hex>  Account color (default: \"#888888\")"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help     display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis account add --name \"Operating Cash\" --type asset --code 1000",
          "  clovis account add --name \"Dining Out\" --type expense --color '#7c3aed'"
        ],
        "notes": []
      },
      "help": "Usage: clovis account add [options]\n\nCreate an account\n\nOptions:\n  --name <name>  Account name\n  --type <type>  Account type: asset, liability, equity, income, or expense\n  --code <code>  Optional account code (default: \"\")\n  --parent <id>  Parent account id\n  --color <hex>  Account color (default: \"#888888\")\n  -h, --help     display help for command\n\nExamples:\n  clovis account add --name \"Operating Cash\" --type asset --code 1000\n  clovis account add --name \"Dining Out\" --type expense --color '#7c3aed'"
    },
    {
      "command": "clovis account balances",
      "slug": "account-balances",
      "path": [
        "account",
        "balances"
      ],
      "usage": "Usage: clovis account balances [options]",
      "description": "List posted, pending, and current balances by account and asset",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--type <type>",
            "description": "Account type",
            "raw": "--type <type>          Account type"
          },
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol",
            "raw": "--asset <id>           Asset id or symbol"
          },
          {
            "term": "--entity <id>",
            "description": "Scope to an account group",
            "raw": "--entity <id>          Scope to an account group"
          },
          {
            "term": "--parent <id>",
            "description": "Alias for --entity",
            "raw": "--parent <id>          Alias for --entity"
          },
          {
            "term": "--account <id>",
            "description": "Restrict to an account or account subtree; may be repeated (default: [])",
            "raw": "--account <id>         Restrict to an account or account subtree; may be repeated (default: [])"
          },
          {
            "term": "--as-of <date>",
            "description": "Balance date, YYYY-MM-DD",
            "raw": "--as-of <date>         Balance date, YYYY-MM-DD"
          },
          {
            "term": "--rollup",
            "description": "Roll balances up through same-type account children",
            "raw": "--rollup               Roll balances up through same-type account children"
          },
          {
            "term": "--native-only",
            "description": "Only include each account's native/default asset",
            "raw": "--native-only          Only include each account's native/default asset"
          },
          {
            "term": "--presentation <mode>",
            "description": "Display mode: ledger, bank, or banking (default: \"ledger\")",
            "raw": "--presentation <mode>  Display mode: ledger, bank, or banking (default: \"ledger\")"
          },
          {
            "term": "--show-zero",
            "description": "Include zero-balance rows",
            "raw": "--show-zero            Include zero-balance rows"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help             display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis account balances --type asset",
          "  clovis account balances --type liability --asset CAD",
          "  clovis --format json account balances --type asset --show-zero"
        ],
        "notes": [
          "Balances are reported in their native asset; Clovis does not silently convert currencies.",
          "Current balance is posted plus pending."
        ]
      },
      "help": "Usage: clovis account balances [options]\n\nList posted, pending, and current balances by account and asset\n\nOptions:\n  --type <type>          Account type\n  --asset <id>           Asset id or symbol\n  --entity <id>          Scope to an account group\n  --parent <id>          Alias for --entity\n  --account <id>         Restrict to an account or account subtree; may be\n                         repeated (default: [])\n  --as-of <date>         Balance date, YYYY-MM-DD\n  --rollup               Roll balances up through same-type account children\n  --native-only          Only include each account's native/default asset\n  --presentation <mode>  Display mode: ledger, bank, or banking (default:\n                         \"ledger\")\n  --show-zero            Include zero-balance rows\n  -h, --help             display help for command\n\nExamples:\n  clovis account balances --type asset\n  clovis account balances --type liability --asset CAD\n  clovis --format json account balances --type asset --show-zero\n\nNotes:\n  Balances are reported in their native asset; Clovis does not silently convert currencies.\n  Current balance is posted plus pending."
    },
    {
      "command": "clovis account list",
      "slug": "account-list",
      "path": [
        "account",
        "list"
      ],
      "usage": "Usage: clovis account list [options]",
      "description": "List accounts",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--type <type>",
            "description": "Account type",
            "raw": "--type <type>  Account type"
          },
          {
            "term": "--parent <id>",
            "description": "Parent account id",
            "raw": "--parent <id>  Parent account id"
          },
          {
            "term": "--tree",
            "description": "Include account tree context",
            "raw": "--tree         Include account tree context"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help     display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis account list",
          "  clovis --format json account list --type expense"
        ],
        "notes": []
      },
      "help": "Usage: clovis account list [options]\n\nList accounts\n\nOptions:\n  --type <type>  Account type\n  --parent <id>  Parent account id\n  --tree         Include account tree context\n  -h, --help     display help for command\n\nExamples:\n  clovis account list\n  clovis --format json account list --type expense"
    },
    {
      "command": "clovis account get",
      "slug": "account-get",
      "path": [
        "account",
        "get"
      ],
      "usage": "Usage: clovis account get [options] <id>",
      "description": "Show one account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis account get [options] <id>\n\nShow one account\n\nOptions:\n  -h, --help  display help for command"
    },
    {
      "command": "clovis account update",
      "slug": "account-update",
      "path": [
        "account",
        "update"
      ],
      "usage": "Usage: clovis account update [options] <id>",
      "description": "Update an account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--name <name>",
            "description": "Account name",
            "raw": "--name <name>  Account name"
          },
          {
            "term": "--type <type>",
            "description": "Account type: asset, liability, equity, income, or expense",
            "raw": "--type <type>  Account type: asset, liability, equity, income, or expense"
          },
          {
            "term": "--code <code>",
            "description": "Optional account code",
            "raw": "--code <code>  Optional account code"
          },
          {
            "term": "--parent <id>",
            "description": "Parent account id",
            "raw": "--parent <id>  Parent account id"
          },
          {
            "term": "--color <hex>",
            "description": "Account color",
            "raw": "--color <hex>  Account color"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help     display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis account update [options] <id>\n\nUpdate an account\n\nOptions:\n  --name <name>  Account name\n  --type <type>  Account type: asset, liability, equity, income, or expense\n  --code <code>  Optional account code\n  --parent <id>  Parent account id\n  --color <hex>  Account color\n  -h, --help     display help for command"
    },
    {
      "command": "clovis account delete",
      "slug": "account-delete",
      "path": [
        "account",
        "delete"
      ],
      "usage": "Usage: clovis account delete [options] <id>",
      "description": "Delete an unused account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis account delete [options] <id>\n\nDelete an unused account\n\nOptions:\n  -h, --help  display help for command"
    },
    {
      "command": "clovis txn",
      "slug": "txn",
      "path": [
        "txn"
      ],
      "usage": "Usage: clovis txn [options] [command]",
      "description": "Manage transactions",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help                      display help for command"
          }
        ],
        "commands": [
          {
            "term": "add [options]",
            "description": "Record a two-sided transaction",
            "raw": "add [options]                   Record a two-sided transaction"
          },
          {
            "term": "transfer [options]",
            "description": "Record a same-asset transfer between balance-sheet accounts",
            "raw": "transfer [options]              Record a same-asset transfer between balance-sheet accounts"
          },
          {
            "term": "journal [options]",
            "description": "Post a manual journal entry",
            "raw": "journal [options]               Post a manual journal entry"
          },
          {
            "term": "opening-balance [options]",
            "description": "Record an opening balance",
            "raw": "opening-balance [options]       Record an opening balance"
          },
          {
            "term": "list [options]",
            "description": "List transactions",
            "raw": "list [options]                  List transactions"
          },
          {
            "term": "get <id>",
            "description": "Show one transaction",
            "raw": "get <id>                        Show one transaction"
          },
          {
            "term": "delete [options] <id>",
            "description": "Void a transaction, or hard-delete with --hard",
            "raw": "delete [options] <id>           Void a transaction, or hard-delete with --hard"
          },
          {
            "term": "entries <tx_id>",
            "description": "List journal entries for a transaction",
            "raw": "entries <tx_id>                 List journal entries for a transaction"
          },
          {
            "term": "recategorize [options] <tx_id>",
            "description": "Recategorize a transaction",
            "raw": "recategorize [options] <tx_id>  Recategorize a transaction"
          },
          {
            "term": "help [command]",
            "description": "display help for command",
            "raw": "help [command]                  display help for command"
          }
        ],
        "examples": [
          "  clovis txn add --date 2026-06-01 --amount 100 --from <income-id> --to <checking-id> --status pending",
          "  clovis txn transfer --date 2026-06-02 --amount 50 --from <checking-id> --to <savings-id>",
          "  clovis txn list --status pending"
        ],
        "notes": []
      },
      "help": "Usage: clovis txn [options] [command]\n\nManage transactions\n\nOptions:\n  -h, --help                      display help for command\n\nCommands:\n  add [options]                   Record a two-sided transaction\n  transfer [options]              Record a same-asset transfer between\n                                  balance-sheet accounts\n  journal [options]               Post a manual journal entry\n  opening-balance [options]       Record an opening balance\n  list [options]                  List transactions\n  get <id>                        Show one transaction\n  delete [options] <id>           Void a transaction, or hard-delete with --hard\n  entries <tx_id>                 List journal entries for a transaction\n  recategorize [options] <tx_id>  Recategorize a transaction\n  help [command]                  display help for command\n\nExamples:\n  clovis txn add --date 2026-06-01 --amount 100 --from <income-id> --to <checking-id> --status pending\n  clovis txn transfer --date 2026-06-02 --amount 50 --from <checking-id> --to <savings-id>\n  clovis txn list --status pending"
    },
    {
      "command": "clovis txn add",
      "slug": "txn-add",
      "path": [
        "txn",
        "add"
      ],
      "usage": "Usage: clovis txn add [options]",
      "description": "Record a two-sided transaction",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--date <date>",
            "description": "Transaction date, YYYY-MM-DD",
            "raw": "--date <date>         Transaction date, YYYY-MM-DD"
          },
          {
            "term": "--amount <amount>",
            "description": "Positive decimal amount in the transaction asset",
            "raw": "--amount <amount>     Positive decimal amount in the transaction asset"
          },
          {
            "term": "--from <id>",
            "description": "Source account id",
            "raw": "--from <id>           Source account id"
          },
          {
            "term": "--to <id>",
            "description": "Destination account id",
            "raw": "--to <id>             Destination account id"
          },
          {
            "term": "--desc <description>",
            "description": "Transaction description (default: \"\")",
            "raw": "--desc <description>  Transaction description (default: \"\")"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status: posted, pending, planned, or void (default: \"pending\")",
            "raw": "--status <status>     Transaction status: posted, pending, planned, or void (default: \"pending\")"
          },
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol; required when account default assets differ",
            "raw": "--asset <id>          Asset id or symbol; required when account default assets differ"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help            display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis txn add --date 2026-06-01 --amount 100 --from <salary-id> --to <checking-id> --desc \"Pay\" --status posted",
          "  clovis txn add --date 2026-06-03 --amount 12.50 --from <checking-id> --to <dining-id>"
        ],
        "notes": [
          "Default status is pending."
        ]
      },
      "help": "Usage: clovis txn add [options]\n\nRecord a two-sided transaction\n\nOptions:\n  --date <date>         Transaction date, YYYY-MM-DD\n  --amount <amount>     Positive decimal amount in the transaction asset\n  --from <id>           Source account id\n  --to <id>             Destination account id\n  --desc <description>  Transaction description (default: \"\")\n  --status <status>     Transaction status: posted, pending, planned, or void\n                        (default: \"pending\")\n  --asset <id>          Asset id or symbol; required when account default assets\n                        differ\n  -h, --help            display help for command\n\nExamples:\n  clovis txn add --date 2026-06-01 --amount 100 --from <salary-id> --to <checking-id> --desc \"Pay\" --status posted\n  clovis txn add --date 2026-06-03 --amount 12.50 --from <checking-id> --to <dining-id>\n\nNotes:\n  Default status is pending."
    },
    {
      "command": "clovis txn transfer",
      "slug": "txn-transfer",
      "path": [
        "txn",
        "transfer"
      ],
      "usage": "Usage: clovis txn transfer [options]",
      "description": "Record a same-asset transfer between balance-sheet accounts",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--from <id>",
            "description": "Source account id",
            "raw": "--from <id>           Source account id"
          },
          {
            "term": "--to <id>",
            "description": "Destination account id",
            "raw": "--to <id>             Destination account id"
          },
          {
            "term": "--amount <amount>",
            "description": "Positive decimal amount",
            "raw": "--amount <amount>     Positive decimal amount"
          },
          {
            "term": "--date <date>",
            "description": "Transaction date, YYYY-MM-DD",
            "raw": "--date <date>         Transaction date, YYYY-MM-DD"
          },
          {
            "term": "--desc <description>",
            "description": "Transfer description (default: \"Transfer\")",
            "raw": "--desc <description>  Transfer description (default: \"Transfer\")"
          },
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol",
            "raw": "--asset <id>          Asset id or symbol"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help            display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis txn transfer --date 2026-06-02 --amount 250 --from <checking-id> --to <savings-id>",
          "  clovis txn transfer --date 2026-06-02 --amount 79 --asset USD --from <usd-checking-id> --to <usd-savings-id>"
        ],
        "notes": []
      },
      "help": "Usage: clovis txn transfer [options]\n\nRecord a same-asset transfer between balance-sheet accounts\n\nOptions:\n  --from <id>           Source account id\n  --to <id>             Destination account id\n  --amount <amount>     Positive decimal amount\n  --date <date>         Transaction date, YYYY-MM-DD\n  --desc <description>  Transfer description (default: \"Transfer\")\n  --asset <id>          Asset id or symbol\n  -h, --help            display help for command\n\nExamples:\n  clovis txn transfer --date 2026-06-02 --amount 250 --from <checking-id> --to <savings-id>\n  clovis txn transfer --date 2026-06-02 --amount 79 --asset USD --from <usd-checking-id> --to <usd-savings-id>"
    },
    {
      "command": "clovis txn journal",
      "slug": "txn-journal",
      "path": [
        "txn",
        "journal"
      ],
      "usage": "Usage: clovis txn journal [options]",
      "description": "Post a manual journal entry",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--date <date>",
            "description": "Journal date, YYYY-MM-DD",
            "raw": "--date <date>         Journal date, YYYY-MM-DD"
          },
          {
            "term": "--leg <leg...>",
            "description": "account_id:amount",
            "raw": "--leg <leg...>        account_id:amount"
          },
          {
            "term": "--desc <description>",
            "description": "Journal description (default: \"\")",
            "raw": "--desc <description>  Journal description (default: \"\")"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status: posted, pending, planned, or void (default: \"pending\")",
            "raw": "--status <status>     Transaction status: posted, pending, planned, or void (default: \"pending\")"
          },
          {
            "term": "--asset <id>",
            "description": "Default asset id or symbol for legs without asset ids",
            "raw": "--asset <id>          Default asset id or symbol for legs without asset ids"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help            display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis txn journal --date 2026-06-30 --leg <debit-account>:10 --leg <credit-account>:-10 --asset CAD"
        ],
        "notes": [
          "Leg amounts must balance per asset."
        ]
      },
      "help": "Usage: clovis txn journal [options]\n\nPost a manual journal entry\n\nOptions:\n  --date <date>         Journal date, YYYY-MM-DD\n  --leg <leg...>        account_id:amount\n  --desc <description>  Journal description (default: \"\")\n  --status <status>     Transaction status: posted, pending, planned, or void\n                        (default: \"pending\")\n  --asset <id>          Default asset id or symbol for legs without asset ids\n  -h, --help            display help for command\n\nExamples:\n  clovis txn journal --date 2026-06-30 --leg <debit-account>:10 --leg <credit-account>:-10 --asset CAD\n\nNotes:\n  Leg amounts must balance per asset."
    },
    {
      "command": "clovis txn opening-balance",
      "slug": "txn-opening-balance",
      "path": [
        "txn",
        "opening-balance"
      ],
      "usage": "Usage: clovis txn opening-balance [options]",
      "description": "Record an opening balance",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--account <id>",
            "description": "Account id receiving the opening balance",
            "raw": "--account <id>      Account id receiving the opening balance"
          },
          {
            "term": "--amount <amount>",
            "description": "Decimal opening amount",
            "raw": "--amount <amount>   Decimal opening amount"
          },
          {
            "term": "--date <date>",
            "description": "Opening date, YYYY-MM-DD",
            "raw": "--date <date>       Opening date, YYYY-MM-DD"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status: posted, pending, planned, or void (default: \"pending\")",
            "raw": "--status <status>   Transaction status: posted, pending, planned, or void (default: \"pending\")"
          },
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol",
            "raw": "--asset <id>        Asset id or symbol"
          },
          {
            "term": "--counterpart <id>",
            "description": "Counterpart equity account id",
            "raw": "--counterpart <id>  Counterpart equity account id"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help          display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis txn opening-balance --account <checking-id> --amount 125 --date 2026-05-31 --status posted"
        ],
        "notes": []
      },
      "help": "Usage: clovis txn opening-balance [options]\n\nRecord an opening balance\n\nOptions:\n  --account <id>      Account id receiving the opening balance\n  --amount <amount>   Decimal opening amount\n  --date <date>       Opening date, YYYY-MM-DD\n  --status <status>   Transaction status: posted, pending, planned, or void\n                      (default: \"pending\")\n  --asset <id>        Asset id or symbol\n  --counterpart <id>  Counterpart equity account id\n  -h, --help          display help for command\n\nExamples:\n  clovis txn opening-balance --account <checking-id> --amount 125 --date 2026-05-31 --status posted"
    },
    {
      "command": "clovis txn list",
      "slug": "txn-list",
      "path": [
        "txn",
        "list"
      ],
      "usage": "Usage: clovis txn list [options]",
      "description": "List transactions",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--account <id>",
            "description": "Filter by account id",
            "raw": "--account <id>     Filter by account id"
          },
          {
            "term": "--year <year>",
            "description": "Filter by UTC year",
            "raw": "--year <year>      Filter by UTC year"
          },
          {
            "term": "--month <month>",
            "description": "Filter by month, 1-12",
            "raw": "--month <month>    Filter by month, 1-12"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "--desc <desc>",
            "description": "Case-insensitive description search",
            "raw": "--desc <desc>      Case-insensitive description search"
          },
          {
            "term": "--limit <n>",
            "description": "Maximum rows (default: \"50\")",
            "raw": "--limit <n>        Maximum rows (default: \"50\")"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis txn list --status pending",
          "  clovis --format json txn list --account <checking-id> --limit 100"
        ],
        "notes": []
      },
      "help": "Usage: clovis txn list [options]\n\nList transactions\n\nOptions:\n  --account <id>     Filter by account id\n  --year <year>      Filter by UTC year\n  --month <month>    Filter by month, 1-12\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  --desc <desc>      Case-insensitive description search\n  --limit <n>        Maximum rows (default: \"50\")\n  -h, --help         display help for command\n\nExamples:\n  clovis txn list --status pending\n  clovis --format json txn list --account <checking-id> --limit 100"
    },
    {
      "command": "clovis txn get",
      "slug": "txn-get",
      "path": [
        "txn",
        "get"
      ],
      "usage": "Usage: clovis txn get [options] <id>",
      "description": "Show one transaction",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis txn get [options] <id>\n\nShow one transaction\n\nOptions:\n  -h, --help  display help for command"
    },
    {
      "command": "clovis txn delete",
      "slug": "txn-delete",
      "path": [
        "txn",
        "delete"
      ],
      "usage": "Usage: clovis txn delete [options] <id>",
      "description": "Void a transaction, or hard-delete with --hard",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--hard",
            "description": "Physically delete instead of voiding",
            "raw": "--hard      Physically delete instead of voiding"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis txn delete [options] <id>\n\nVoid a transaction, or hard-delete with --hard\n\nOptions:\n  --hard      Physically delete instead of voiding\n  -h, --help  display help for command"
    },
    {
      "command": "clovis txn entries",
      "slug": "txn-entries",
      "path": [
        "txn",
        "entries"
      ],
      "usage": "Usage: clovis txn entries [options] <tx_id>",
      "description": "List journal entries for a transaction",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis txn entries [options] <tx_id>\n\nList journal entries for a transaction\n\nOptions:\n  -h, --help  display help for command"
    },
    {
      "command": "clovis txn recategorize",
      "slug": "txn-recategorize",
      "path": [
        "txn",
        "recategorize"
      ],
      "usage": "Usage: clovis txn recategorize [options] <tx_id>",
      "description": "Recategorize a transaction",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--from <id>",
            "description": "Current account id",
            "raw": "--from <id>  Current account id"
          },
          {
            "term": "--to <id>",
            "description": "New account id",
            "raw": "--to <id>    New account id"
          },
          {
            "term": "--dry-run",
            "description": "Preview the correction without applying it",
            "raw": "--dry-run    Preview the correction without applying it"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help   display help for command"
          }
        ],
        "commands": [],
        "examples": [],
        "notes": []
      },
      "help": "Usage: clovis txn recategorize [options] <tx_id>\n\nRecategorize a transaction\n\nOptions:\n  --from <id>  Current account id\n  --to <id>    New account id\n  --dry-run    Preview the correction without applying it\n  -h, --help   display help for command"
    },
    {
      "command": "clovis balance",
      "slug": "balance",
      "path": [
        "balance"
      ],
      "usage": "Usage: clovis balance [options] <account_id>",
      "description": "Show posted balances for an account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help  display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis balance <checking-id>"
        ],
        "notes": [
          "Use `clovis account balances` for posted, pending, and current balances across accounts."
        ]
      },
      "help": "Usage: clovis balance [options] <account_id>\n\nShow posted balances for an account\n\nOptions:\n  -h, --help  display help for command\n\nExamples:\n  clovis balance <checking-id>\n\nNotes:\n  Use `clovis account balances` for posted, pending, and current balances across accounts."
    },
    {
      "command": "clovis init",
      "slug": "init",
      "path": [
        "init"
      ],
      "usage": "Usage: clovis init [options]",
      "description": "Initialize a ledger with default accounts",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--template <template>",
            "description": "Default account template (default: \"personal\")",
            "raw": "--template <template>  Default account template (default: \"personal\")"
          },
          {
            "term": "--currency <symbol>",
            "description": "Explicit setup currency symbol, e.g. CAD or USD",
            "raw": "--currency <symbol>    Explicit setup currency symbol, e.g. CAD or USD"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help             display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis init --currency CAD"
        ],
        "notes": [
          "Clovis does not infer a default currency."
        ]
      },
      "help": "Usage: clovis init [options]\n\nInitialize a ledger with default accounts\n\nOptions:\n  --template <template>  Default account template (default: \"personal\")\n  --currency <symbol>    Explicit setup currency symbol, e.g. CAD or USD\n  -h, --help             display help for command\n\nExamples:\n  clovis init --currency CAD\n\nNotes:\n  Clovis does not infer a default currency."
    },
    {
      "command": "clovis export",
      "slug": "export",
      "path": [
        "export"
      ],
      "usage": "Usage: clovis export [options]",
      "description": "Export transactions as CSV",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--account <id>",
            "description": "Filter by account id",
            "raw": "--account <id>     Filter by account id"
          },
          {
            "term": "--from <date>",
            "description": "Start date, YYYY-MM-DD",
            "raw": "--from <date>      Start date, YYYY-MM-DD"
          },
          {
            "term": "--to <date>",
            "description": "End date, YYYY-MM-DD",
            "raw": "--to <date>        End date, YYYY-MM-DD"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "--output <path>",
            "description": "Write CSV file",
            "raw": "--output <path>    Write CSV file"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis export --from 2026-06-01 --to 2026-06-30 --output june.csv",
          "  clovis --format json export --account <checking-id>"
        ],
        "notes": []
      },
      "help": "Usage: clovis export [options]\n\nExport transactions as CSV\n\nOptions:\n  --account <id>     Filter by account id\n  --from <date>      Start date, YYYY-MM-DD\n  --to <date>        End date, YYYY-MM-DD\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  --output <path>    Write CSV file\n  -h, --help         display help for command\n\nExamples:\n  clovis export --from 2026-06-01 --to 2026-06-30 --output june.csv\n  clovis --format json export --account <checking-id>"
    },
    {
      "command": "clovis import",
      "slug": "import",
      "path": [
        "import"
      ],
      "usage": "Usage: clovis import [options]",
      "description": "Import a CSV statement into an account",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--file <path>",
            "description": "CSV file path",
            "raw": "--file <path>        CSV file path"
          },
          {
            "term": "--account <id>",
            "description": "Destination account id",
            "raw": "--account <id>       Destination account id"
          },
          {
            "term": "--counterpart <id>",
            "description": "Counterpart/category account id for imported rows",
            "raw": "--counterpart <id>   Counterpart/category account id for imported rows"
          },
          {
            "term": "--currency <symbol>",
            "description": "Explicit asset symbol if the file differs from the account default",
            "raw": "--currency <symbol>  Explicit asset symbol if the file differs from the account default"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status: posted, pending, planned, or void (default: \"pending\")",
            "raw": "--status <status>    Transaction status: posted, pending, planned, or void (default: \"pending\")"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help           display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis import --file statement.csv --account <checking-id> --counterpart <uncategorized-id>",
          "  clovis import --file visa.csv --account <card-id> --counterpart <uncategorized-id> --status pending"
        ],
        "notes": [
          "Default status is pending so imported rows can be reviewed before posting.",
          "File paths use ordinary filesystem permissions."
        ]
      },
      "help": "Usage: clovis import [options]\n\nImport a CSV statement into an account\n\nOptions:\n  --file <path>        CSV file path\n  --account <id>       Destination account id\n  --counterpart <id>   Counterpart/category account id for imported rows\n  --currency <symbol>  Explicit asset symbol if the file differs from the\n                       account default\n  --status <status>    Transaction status: posted, pending, planned, or void\n                       (default: \"pending\")\n  -h, --help           display help for command\n\nExamples:\n  clovis import --file statement.csv --account <checking-id> --counterpart <uncategorized-id>\n  clovis import --file visa.csv --account <card-id> --counterpart <uncategorized-id> --status pending\n\nNotes:\n  Default status is pending so imported rows can be reviewed before posting.\n  File paths use ordinary filesystem permissions."
    },
    {
      "command": "clovis report",
      "slug": "report",
      "path": [
        "report"
      ],
      "usage": "Usage: clovis report [options] [command]",
      "description": "Run accounting reports",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help                  display help for command"
          }
        ],
        "commands": [
          {
            "term": "income-statement [options]",
            "description": "Report income, expenses, and net income",
            "raw": "income-statement [options]  Report income, expenses, and net income"
          },
          {
            "term": "balance-sheet [options]",
            "description": "Report assets, liabilities, and equity",
            "raw": "balance-sheet [options]     Report assets, liabilities, and equity"
          },
          {
            "term": "net-worth [options]",
            "description": "Report net worth",
            "raw": "net-worth [options]         Report net worth"
          },
          {
            "term": "spending [options]",
            "description": "Report spending by category",
            "raw": "spending [options]          Report spending by category"
          },
          {
            "term": "cash-flow [options]",
            "description": "Report cash flow by activity",
            "raw": "cash-flow [options]         Report cash flow by activity"
          },
          {
            "term": "register [options]",
            "description": "Show an account register",
            "raw": "register [options]          Show an account register"
          },
          {
            "term": "trial-balance [options]",
            "description": "Show debit and credit totals for one asset",
            "raw": "trial-balance [options]     Show debit and credit totals for one asset"
          },
          {
            "term": "help [command]",
            "description": "display help for command",
            "raw": "help [command]              display help for command"
          }
        ],
        "examples": [
          "  clovis report balance-sheet --quote CAD",
          "  clovis report income-statement --year 2026 --month 6 --quote CAD",
          "  clovis report register --account <checking-id> --status posted"
        ],
        "notes": [
          "Reports require explicit quote assets; Clovis does not infer report currency."
        ]
      },
      "help": "Usage: clovis report [options] [command]\n\nRun accounting reports\n\nOptions:\n  -h, --help                  display help for command\n\nCommands:\n  income-statement [options]  Report income, expenses, and net income\n  balance-sheet [options]     Report assets, liabilities, and equity\n  net-worth [options]         Report net worth\n  spending [options]          Report spending by category\n  cash-flow [options]         Report cash flow by activity\n  register [options]          Show an account register\n  trial-balance [options]     Show debit and credit totals for one asset\n  help [command]              display help for command\n\nExamples:\n  clovis report balance-sheet --quote CAD\n  clovis report income-statement --year 2026 --month 6 --quote CAD\n  clovis report register --account <checking-id> --status posted\n\nNotes:\n  Reports require explicit quote assets; Clovis does not infer report currency."
    },
    {
      "command": "clovis report income-statement",
      "slug": "report-income-statement",
      "path": [
        "report",
        "income-statement"
      ],
      "usage": "Usage: clovis report income-statement [options]",
      "description": "Report income, expenses, and net income",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--year <year>",
            "description": "UTC year",
            "raw": "--year <year>    UTC year"
          },
          {
            "term": "--month <month>",
            "description": "Month, 1-12",
            "raw": "--month <month>  Month, 1-12"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset symbol or id",
            "raw": "--quote <asset>  Quote asset symbol or id"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help       display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report income-statement --year 2026 --month 6 --quote CAD"
        ],
        "notes": []
      },
      "help": "Usage: clovis report income-statement [options]\n\nReport income, expenses, and net income\n\nOptions:\n  --year <year>    UTC year\n  --month <month>  Month, 1-12\n  --quote <asset>  Quote asset symbol or id\n  -h, --help       display help for command\n\nExamples:\n  clovis report income-statement --year 2026 --month 6 --quote CAD"
    },
    {
      "command": "clovis report balance-sheet",
      "slug": "report-balance-sheet",
      "path": [
        "report",
        "balance-sheet"
      ],
      "usage": "Usage: clovis report balance-sheet [options]",
      "description": "Report assets, liabilities, and equity",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--date <date>",
            "description": "As-of date, YYYY-MM-DD",
            "raw": "--date <date>      As-of date, YYYY-MM-DD"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset symbol or id",
            "raw": "--quote <asset>    Quote asset symbol or id"
          },
          {
            "term": "--entity <id>",
            "description": "Scope to an account group",
            "raw": "--entity <id>      Scope to an account group"
          },
          {
            "term": "--parent <id>",
            "description": "Alias for --entity",
            "raw": "--parent <id>      Alias for --entity"
          },
          {
            "term": "--account <id>",
            "description": "Restrict to an account or account subtree; may be repeated (default: [])",
            "raw": "--account <id>     Restrict to an account or account subtree; may be repeated (default: [])"
          },
          {
            "term": "--include-pending",
            "description": "Include pending transactions; current balance-sheet reports include them by default",
            "raw": "--include-pending  Include pending transactions; current balance-sheet reports include them by default"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "--hide-zero",
            "description": "Hide zero-balance rows",
            "raw": "--hide-zero        Hide zero-balance rows"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report balance-sheet --date 2026-06-30 --quote CAD --parent Personal"
        ],
        "notes": []
      },
      "help": "Usage: clovis report balance-sheet [options]\n\nReport assets, liabilities, and equity\n\nOptions:\n  --date <date>      As-of date, YYYY-MM-DD\n  --quote <asset>    Quote asset symbol or id\n  --entity <id>      Scope to an account group\n  --parent <id>      Alias for --entity\n  --account <id>     Restrict to an account or account subtree; may be repeated\n                     (default: [])\n  --include-pending  Include pending transactions; current balance-sheet reports\n                     include them by default\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  --hide-zero        Hide zero-balance rows\n  -h, --help         display help for command\n\nExamples:\n  clovis report balance-sheet --date 2026-06-30 --quote CAD --parent Personal"
    },
    {
      "command": "clovis report net-worth",
      "slug": "report-net-worth",
      "path": [
        "report",
        "net-worth"
      ],
      "usage": "Usage: clovis report net-worth [options]",
      "description": "Report net worth",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--date <date>",
            "description": "As-of date, YYYY-MM-DD",
            "raw": "--date <date>      As-of date, YYYY-MM-DD"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset symbol or id",
            "raw": "--quote <asset>    Quote asset symbol or id"
          },
          {
            "term": "--entity <id>",
            "description": "Scope to an account group",
            "raw": "--entity <id>      Scope to an account group"
          },
          {
            "term": "--parent <id>",
            "description": "Alias for --entity",
            "raw": "--parent <id>      Alias for --entity"
          },
          {
            "term": "--account <id>",
            "description": "Restrict to an account or account subtree; may be repeated (default: [])",
            "raw": "--account <id>     Restrict to an account or account subtree; may be repeated (default: [])"
          },
          {
            "term": "--include-pending",
            "description": "Include pending transactions; current net-worth reports include them by default",
            "raw": "--include-pending  Include pending transactions; current net-worth reports include them by default"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report net-worth --quote CAD --parent Personal"
        ],
        "notes": []
      },
      "help": "Usage: clovis report net-worth [options]\n\nReport net worth\n\nOptions:\n  --date <date>      As-of date, YYYY-MM-DD\n  --quote <asset>    Quote asset symbol or id\n  --entity <id>      Scope to an account group\n  --parent <id>      Alias for --entity\n  --account <id>     Restrict to an account or account subtree; may be repeated\n                     (default: [])\n  --include-pending  Include pending transactions; current net-worth reports\n                     include them by default\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  -h, --help         display help for command\n\nExamples:\n  clovis report net-worth --quote CAD --parent Personal"
    },
    {
      "command": "clovis report spending",
      "slug": "report-spending",
      "path": [
        "report",
        "spending"
      ],
      "usage": "Usage: clovis report spending [options]",
      "description": "Report spending by category",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--year <year>",
            "description": "UTC year",
            "raw": "--year <year>    UTC year"
          },
          {
            "term": "--month <month>",
            "description": "Month, 1-12",
            "raw": "--month <month>  Month, 1-12"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset symbol or id",
            "raw": "--quote <asset>  Quote asset symbol or id"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help       display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report spending --year 2026 --month 6 --quote CAD"
        ],
        "notes": []
      },
      "help": "Usage: clovis report spending [options]\n\nReport spending by category\n\nOptions:\n  --year <year>    UTC year\n  --month <month>  Month, 1-12\n  --quote <asset>  Quote asset symbol or id\n  -h, --help       display help for command\n\nExamples:\n  clovis report spending --year 2026 --month 6 --quote CAD"
    },
    {
      "command": "clovis report cash-flow",
      "slug": "report-cash-flow",
      "path": [
        "report",
        "cash-flow"
      ],
      "usage": "Usage: clovis report cash-flow [options]",
      "description": "Report cash flow by activity",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--year <year>",
            "description": "UTC year",
            "raw": "--year <year>    UTC year"
          },
          {
            "term": "--month <month>",
            "description": "Month, 1-12",
            "raw": "--month <month>  Month, 1-12"
          },
          {
            "term": "--quote <asset>",
            "description": "Quote asset symbol or id",
            "raw": "--quote <asset>  Quote asset symbol or id"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help       display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report cash-flow --year 2026 --month 6 --quote CAD"
        ],
        "notes": []
      },
      "help": "Usage: clovis report cash-flow [options]\n\nReport cash flow by activity\n\nOptions:\n  --year <year>    UTC year\n  --month <month>  Month, 1-12\n  --quote <asset>  Quote asset symbol or id\n  -h, --help       display help for command\n\nExamples:\n  clovis report cash-flow --year 2026 --month 6 --quote CAD"
    },
    {
      "command": "clovis report register",
      "slug": "report-register",
      "path": [
        "report",
        "register"
      ],
      "usage": "Usage: clovis report register [options]",
      "description": "Show an account register",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--account <id>",
            "description": "Account id",
            "raw": "--account <id>     Account id"
          },
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol",
            "raw": "--asset <id>       Asset id or symbol"
          },
          {
            "term": "--from <date>",
            "description": "Start date, YYYY-MM-DD",
            "raw": "--from <date>      Start date, YYYY-MM-DD"
          },
          {
            "term": "--to <date>",
            "description": "End date, YYYY-MM-DD",
            "raw": "--to <date>        End date, YYYY-MM-DD"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report register --account <checking-id> --from 2026-06-01 --to 2026-06-30"
        ],
        "notes": []
      },
      "help": "Usage: clovis report register [options]\n\nShow an account register\n\nOptions:\n  --account <id>     Account id\n  --asset <id>       Asset id or symbol\n  --from <date>      Start date, YYYY-MM-DD\n  --to <date>        End date, YYYY-MM-DD\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  -h, --help         display help for command\n\nExamples:\n  clovis report register --account <checking-id> --from 2026-06-01 --to 2026-06-30"
    },
    {
      "command": "clovis report trial-balance",
      "slug": "report-trial-balance",
      "path": [
        "report",
        "trial-balance"
      ],
      "usage": "Usage: clovis report trial-balance [options]",
      "description": "Show debit and credit totals for one asset",
      "sections": {
        "arguments": [],
        "options": [
          {
            "term": "--asset <id>",
            "description": "Asset id or symbol",
            "raw": "--asset <id>       Asset id or symbol"
          },
          {
            "term": "--status <status>",
            "description": "Transaction status filter: posted, pending, planned, void, active, combined, or all",
            "raw": "--status <status>  Transaction status filter: posted, pending, planned, void, active, combined, or all"
          },
          {
            "term": "-h, --help",
            "description": "display help for command",
            "raw": "-h, --help         display help for command"
          }
        ],
        "commands": [],
        "examples": [
          "  clovis report trial-balance --asset CAD"
        ],
        "notes": []
      },
      "help": "Usage: clovis report trial-balance [options]\n\nShow debit and credit totals for one asset\n\nOptions:\n  --asset <id>       Asset id or symbol\n  --status <status>  Transaction status filter: posted, pending, planned, void,\n                     active, combined, or all\n  -h, --help         display help for command\n\nExamples:\n  clovis report trial-balance --asset CAD"
    }
  ],
  "tools": [
    {
      "name": "account_balances",
      "title": "Account Balances",
      "category": "Ledger and accounts",
      "summary": "Shows posted, pending, and current balances by account and asset.",
      "signature": "(account_type?: string | null, asset_id?: string | null, as_of?: string | null, rollup?: boolean, hide_zero?: boolean, native_asset_only?: boolean, presentation?: string, account_ids?: string[] | null, entity_id?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "account_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account type filter, such as asset, liability, equity, income, or expense."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "as_of",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        },
        {
          "name": "rollup",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "hide_zero",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Hides zero-balance rows from the response."
        },
        {
          "name": "native_asset_only",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Currency or asset symbol/id."
        },
        {
          "name": "presentation",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "ledger",
          "description": "Input used by this tool."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows posted, pending, and current balances by account and asset.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "account_register",
      "title": "Account Register",
      "category": "Ledger and accounts",
      "summary": "Shows the transaction register for one account, with date, status, branch, and pagination filters.",
      "signature": "(account_id: string, asset_id?: string | null, date_from?: string | null, date_to?: string | null, time_from?: string | null, time_to?: string | null, branch?: string | null, status?: string | null, limit?: number, offset?: number, summary?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "time_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start timestamp filter."
        },
        {
          "name": "time_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End timestamp filter."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 100,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        },
        {
          "name": "summary",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows the transaction register for one account, with date, status, branch, and pagination filters.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "add_match_rule",
      "title": "Add Match Rule",
      "category": "Import, review, and reconciliation",
      "summary": "Adds match rule in the local Clovis ledger.",
      "signature": "(account_id: string, pattern: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "pattern",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Text or regular-expression pattern used to match descriptions."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Adds match rule in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, pattern.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "pattern": "<pattern>"
        }
      }
    },
    {
      "name": "add_match_rules",
      "title": "Add Match Rules",
      "category": "Import, review, and reconciliation",
      "summary": "Adds match rules in the local Clovis ledger.",
      "signature": "(rules: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "rules",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Match rules to create or apply."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Adds match rules in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: rules.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "rules": []
        }
      }
    },
    {
      "name": "age_of_money",
      "title": "Age Of Money",
      "category": "Core tools",
      "summary": "Estimates age of money in the local Clovis ledger.",
      "signature": "(days?: number, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 30,
          "description": "Number of days to include in the calculation."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Estimates age of money in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "apply_match_rules",
      "title": "Apply Match Rules",
      "category": "Import, review, and reconciliation",
      "summary": "Applies saved categorization rules to pending transactions, with dry-run on by default.",
      "signature": "(catch_all_account_id: string, date_from?: string | null, date_to?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "catch_all_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Fallback category account for rows that do not match a rule."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Applies saved categorization rules to pending transactions, with dry-run on by default.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: catch_all_account_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "catch_all_account_id": "<catch_all_account_id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "apply_pattern",
      "title": "Apply Pattern",
      "category": "Core tools",
      "summary": "Recategorizes transactions that match a description pattern, optionally saving the pattern as a rule.",
      "signature": "(pattern: string, target_account: string, force?: boolean, persist_rule?: boolean, dry_run?: boolean, source_account?: string | null, date_from?: string | null, date_to?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "pattern",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Text or regular-expression pattern used to match descriptions."
        },
        {
          "name": "target_account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Target category or account for the matched rows."
        },
        {
          "name": "force",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Allows the operation to continue through conflicts that would otherwise stop it."
        },
        {
          "name": "persist_rule",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Saves the pattern as a future match rule."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "source_account",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional source account filter."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Recategorizes transactions that match a description pattern, optionally saving the pattern as a rule.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: pattern, target_account.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "pattern": "<pattern>",
          "target_account": "<target_account>",
          "dry_run": true
        }
      }
    },
    {
      "name": "apply_reconciliation_plan",
      "title": "Apply Reconciliation Plan",
      "category": "Core tools",
      "summary": "Applies a prepared statement reconciliation plan, usually after reviewing the proposed matches and imports.",
      "signature": "(file_path?: string | null, plan_id?: string | null, account_id?: string | null, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, min_likely_score?: number, row_indexes?: number[] | null, commit_imported?: boolean, annotate_posted_matches?: boolean, allow_review_skip?: boolean, require_balance_match?: boolean, sample_limit?: number, include_details?: boolean, verbosity?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "plan_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Previously generated plan id."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "expected_balance",
          "type": "number",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement ending balance expected after reconciliation."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        },
        {
          "name": "balance_sign",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "min_likely_score",
          "type": "number",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0.72,
          "description": "Minimum confidence score for accepting likely reconciliation matches."
        },
        {
          "name": "row_indexes",
          "type": "integer[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement row indexes to apply or inspect."
        },
        {
          "name": "commit_imported",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "annotate_posted_matches",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Adds match annotations to already-posted transactions when applying the plan."
        },
        {
          "name": "allow_review_skip",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Allows the workflow to proceed even when review items remain."
        },
        {
          "name": "require_balance_match",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Requires the final balance to match the statement expectation."
        },
        {
          "name": "sample_limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 20,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "include_details",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "verbosity",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Applies a prepared statement reconciliation plan, usually after reviewing the proposed matches and imports.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "apply_rollover",
      "title": "Apply Rollover",
      "category": "Core tools",
      "summary": "Applies rollover in the local Clovis ledger.",
      "signature": "(year: number, month: number, quote_asset_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Applies rollover in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: year, month, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "year": 1,
          "month": 6,
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "assert_balance",
      "title": "Assert Balance",
      "category": "Ledger and accounts",
      "summary": "Checks balance in the local Clovis ledger.",
      "signature": "(account_id: string, expected: number, date?: string | null, asset_id?: string | null, status?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "expected",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Expected balance amount to compare with the ledger."
        },
        {
          "name": "date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Checks balance in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, expected."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "expected": 1
        }
      }
    },
    {
      "name": "assert_balances",
      "title": "Assert Balances",
      "category": "Ledger and accounts",
      "summary": "Checks balances in the local Clovis ledger.",
      "signature": "(assertions: unknown[], status?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "assertions",
          "type": "array",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Balance assertions to check against the ledger."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Checks balances in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: assertions."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "assertions": []
        }
      }
    },
    {
      "name": "audit_categorization",
      "title": "Audit Categorization",
      "category": "Import, review, and reconciliation",
      "summary": "Audits categorization in the local Clovis ledger.",
      "signature": "(date_from?: string | null, date_to?: string | null, catch_all_account_id?: string | null, min_occurrences?: number, status?: string, mode?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "catch_all_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Fallback category account for rows that do not match a rule."
        },
        {
          "name": "min_occurrences",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 2,
          "description": "Minimum repeated occurrences required before a pattern is reported."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "mode",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "budget",
          "description": "Workflow mode used by the tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Audits categorization in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "backup_now",
      "title": "Backup Now",
      "category": "Maintenance and safety",
      "summary": "Creates a local backup of the selected Clovis ledger.",
      "signature": "(output_path?: string | null, compact?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "output_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local output path for a generated file or backup."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Returns a smaller response shape when true."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates a local backup of the selected Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it before or after risky operations to back up, inspect, or repair the ledger.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "backup_status",
      "title": "Backup Status",
      "category": "Maintenance and safety",
      "summary": "Shows backup configuration and recent backup state for the local ledger.",
      "signature": "() => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows backup configuration and recent backup state for the local ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it before or after risky operations to back up, inspect, or repair the ledger."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "balance_sheet",
      "title": "Balance Sheet",
      "category": "Ledger and accounts",
      "summary": "Builds an assets, liabilities, and equity report for a date or scenario branch.",
      "signature": "(date?: string | null, branch?: string | null, compact?: boolean, include_pending?: boolean, status?: string, hide_zero?: boolean, quote_asset_id: string, account_ids?: string[] | null, entity_id?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Returns a smaller response shape when true."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "active",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "hide_zero",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Hides zero-balance rows from the response."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Builds an assets, liabilities, and equity report for a date or scenario branch.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "budget_rollover_preview",
      "title": "Budget Rollover Preview",
      "category": "Import, review, and reconciliation",
      "summary": "Runs budget rollover preview in the local Clovis ledger.",
      "signature": "(year: number, month: number, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Runs budget rollover preview in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: year, month, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "year": 1,
          "month": 6,
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "budget_status",
      "title": "Budget Status",
      "category": "Planning and cash flow",
      "summary": "Shows budget status in the local Clovis ledger.",
      "signature": "(account?: string | null, year?: number | null, month?: number | null, rollup?: boolean, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account name or id to inspect."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "rollup",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows budget status in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "budget_summary",
      "title": "Budget Summary",
      "category": "Planning and cash flow",
      "summary": "Summarizes budget summary in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Summarizes budget summary in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "buy_security",
      "title": "Buy Security",
      "category": "Assets and investments",
      "summary": "Records security in the local Clovis ledger.",
      "signature": "(account_id: string, symbol: string, shares: number, total_cost_cents: number, date: string, commission_cents?: number, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "symbol",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "shares",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "total_cost_cents",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "commission_cents",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records security in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, symbol, shares, total_cost_cents, date.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "symbol": "<symbol>",
          "shares": 1,
          "total_cost_cents": 1,
          "date": "2026-06-01"
        }
      }
    },
    {
      "name": "cash_flow",
      "title": "Cash Flow",
      "category": "Planning and cash flow",
      "summary": "Reports cash flow in the local Clovis ledger.",
      "signature": "(year: number, month: number, branch?: string | null, compact?: boolean, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Returns a smaller response shape when true."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reports cash flow in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: year, month, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "year": 1,
          "month": 6,
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "cash_projection",
      "title": "Cash Projection",
      "category": "Planning and cash flow",
      "summary": "Projects cash projection in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, entity_id?: string | null, earmarks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, planned_match_tolerance_days?: number, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "asset_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset account ids to include in a projection."
        },
        {
          "name": "liability_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of identifiers from the local Clovis ledger."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "earmarks",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "include_planned",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes planned transactions in the calculation."
        },
        {
          "name": "planned_match_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Projects cash projection in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "cash_runway",
      "title": "Cash Runway",
      "category": "Planning and cash flow",
      "summary": "Estimates how long spendable cash can cover burn, based on the selected assumptions.",
      "signature": "(year?: number | null, month?: number | null, as_of?: string | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, earmarks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, include_partial_month?: boolean, reserve_remaining_budget?: boolean, include_sources?: boolean, summary?: boolean, trailing_months_short?: number, trailing_months_long?: number, discretionary_multiplier?: number, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "as_of",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        },
        {
          "name": "asset_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset account ids to include in a projection."
        },
        {
          "name": "liability_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of identifiers from the local Clovis ledger."
        },
        {
          "name": "earmarks",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "include_planned",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes planned transactions in the calculation."
        },
        {
          "name": "include_partial_month",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "reserve_remaining_budget",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "include_sources",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "summary",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "trailing_months_short",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "trailing_months_long",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 6,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "discretionary_multiplier",
          "type": "number",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0.5,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Estimates how long spendable cash can cover burn, based on the selected assumptions.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "close_period",
      "title": "Close Period",
      "category": "Core tools",
      "summary": "Closes period in the local Clovis ledger.",
      "signature": "(name: string, as_of: string, description?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        },
        {
          "name": "as_of",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        },
        {
          "name": "description",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human-readable transaction, account, rule, or journal description."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Closes period in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: name, as_of.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "name": "<name>",
          "as_of": "2026-06-01"
        }
      }
    },
    {
      "name": "commit_batch",
      "title": "Commit Batch",
      "category": "Core tools",
      "summary": "Commits batch in the local Clovis ledger.",
      "signature": "(tx_ids?: string[] | null, batch_id?: string | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tx_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of transaction ids."
        },
        {
          "name": "batch_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Import, commit, or mutation batch id."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Commits batch in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "compare_scenarios",
      "title": "Compare Scenarios",
      "category": "Scenarios",
      "summary": "Compares scenarios in the local Clovis ledger.",
      "signature": "(as_of_a?: string | null, as_of_b?: string | null, asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "as_of_a",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "as_of_b",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Compares scenarios in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD"
        }
      }
    },
    {
      "name": "consolidate_transfers",
      "title": "Consolidate Transfers",
      "category": "Core tools",
      "summary": "Consolidates transfers in the local Clovis ledger.",
      "signature": "(account_a: string, account_b: string, transfer_account_id?: string | null, date_tolerance_days?: number, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_a",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "account_b",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "transfer_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 1,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Consolidates transfers in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_a, account_b.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_a": "<account_a>",
          "account_b": "<account_b>",
          "dry_run": true
        }
      }
    },
    {
      "name": "copy_budgets",
      "title": "Copy Budgets",
      "category": "Planning and cash flow",
      "summary": "Copies budgets in the local Clovis ledger.",
      "signature": "(from_year: number, from_month: number, to_year: number, to_month: number, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "from_year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "from_month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "to_year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "to_month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Copies budgets in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: from_year, from_month, to_year, to_month.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "from_year": 1,
          "from_month": 1,
          "to_year": 1,
          "to_month": 1
        }
      }
    },
    {
      "name": "count_transactions",
      "title": "Count Transactions",
      "category": "Ledger and accounts",
      "summary": "Counts transactions in the local Clovis ledger.",
      "signature": "(account_id?: string | null, status?: string | null, date_from?: string | null, date_to?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Counts transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "create_account",
      "title": "Create Account",
      "category": "Ledger and accounts",
      "summary": "Creates account in the local Clovis ledger.",
      "signature": "(name: string, type: string, code?: string, parent_id?: string | null, color_hex?: string, default_asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        },
        {
          "name": "type",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "code",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "",
          "description": "Input used by this tool."
        },
        {
          "name": "parent_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Parent account id."
        },
        {
          "name": "color_hex",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "#888888",
          "description": "Display color for the account or asset."
        },
        {
          "name": "default_asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates account in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: name, type.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "name": "<name>",
          "type": "<type>"
        }
      }
    },
    {
      "name": "create_accounts",
      "title": "Create Accounts",
      "category": "Ledger and accounts",
      "summary": "Creates accounts in the local Clovis ledger.",
      "signature": "(accounts: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "accounts",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates accounts in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: accounts.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "accounts": []
        }
      }
    },
    {
      "name": "create_asset",
      "title": "Create Asset",
      "category": "Assets and investments",
      "summary": "Creates asset in the local Clovis ledger.",
      "signature": "(symbol: string, asset_type?: string, decimals?: number, name?: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "symbol",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "asset_type",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "currency",
          "description": "Currency or asset symbol/id."
        },
        {
          "name": "decimals",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 2,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "name",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "",
          "description": "Human-readable name to create or update."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates asset in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: symbol.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "symbol": "<symbol>"
        }
      }
    },
    {
      "name": "create_branch",
      "title": "Create Branch",
      "category": "Scenarios",
      "summary": "Creates scenario branch in the local Clovis ledger.",
      "signature": "(name: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates scenario branch in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: name.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "name": "<name>"
        }
      }
    },
    {
      "name": "create_price",
      "title": "Create Price",
      "category": "Assets and investments",
      "summary": "Creates price in the local Clovis ledger.",
      "signature": "(asset_id: string, quote_id: string, rate: number, time: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "quote_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "rate",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "time",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {
        "quote_asset_id": "quote_id",
        "quote": "quote_id",
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates price in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id, quote_id, rate, time.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD",
          "quote_id": "USD",
          "rate": 1,
          "time": "<time>"
        }
      }
    },
    {
      "name": "create_scheduled_transaction",
      "title": "Create Scheduled Transaction",
      "category": "Ledger and accounts",
      "summary": "Creates scheduled transactions transaction in the local Clovis ledger.",
      "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description?: string, frequency?: string, end_date?: string | null, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "from_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for a transaction or transfer."
        },
        {
          "name": "to_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Destination account id for a transaction or transfer."
        },
        {
          "name": "description",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "",
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "frequency",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "monthly",
          "description": "Schedule frequency, such as monthly."
        },
        {
          "name": "end_date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Final date for a scheduled or recurring workflow."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates scheduled transactions transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, amount, from_account_id, to_account_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "amount": 100,
          "from_account_id": "<from_account_id>",
          "to_account_id": "<to_account_id>"
        }
      }
    },
    {
      "name": "create_transaction",
      "title": "Create Transaction",
      "category": "Ledger and accounts",
      "summary": "Creates transaction in the local Clovis ledger.",
      "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description: string, status?: string, asset_id?: string | null, branch?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "from_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for a transaction or transfer."
        },
        {
          "name": "to_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Destination account id for a transaction or transfer."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Creates transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, amount, from_account_id, to_account_id, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "amount": 100,
          "from_account_id": "<from_account_id>",
          "to_account_id": "<to_account_id>",
          "description": "<description>"
        }
      }
    },
    {
      "name": "delete_account",
      "title": "Delete Account",
      "category": "Ledger and accounts",
      "summary": "Deletes account in the local Clovis ledger.",
      "signature": "(id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes account in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "id": "<id>"
        }
      }
    },
    {
      "name": "delete_asset",
      "title": "Delete Asset",
      "category": "Assets and investments",
      "summary": "Deletes asset in the local Clovis ledger.",
      "signature": "(asset_id: string, force?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "force",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Allows the operation to continue through conflicts that would otherwise stop it."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes asset in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD"
        }
      }
    },
    {
      "name": "delete_budget",
      "title": "Delete Budget",
      "category": "Planning and cash flow",
      "summary": "Deletes budget in the local Clovis ledger.",
      "signature": "(account: string, year?: number | null, month?: number | null, include_overrides?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account name or id to inspect."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "include_overrides",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes budget in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account": "<account>"
        }
      }
    },
    {
      "name": "delete_budgets",
      "title": "Delete Budgets",
      "category": "Planning and cash flow",
      "summary": "Deletes budgets in the local Clovis ledger.",
      "signature": "(accounts?: string[] | null, year?: number | null, month?: number | null, include_overrides?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "accounts",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "include_overrides",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes budgets in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "delete_goal",
      "title": "Delete Goal",
      "category": "Planning and cash flow",
      "summary": "Deletes goal in the local Clovis ledger.",
      "signature": "(account: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account name or id to inspect."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes goal in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account": "<account>"
        }
      }
    },
    {
      "name": "delete_match_rule",
      "title": "Delete Match Rule",
      "category": "Import, review, and reconciliation",
      "summary": "Deletes match rule in the local Clovis ledger.",
      "signature": "(account_id: string, pattern: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "pattern",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Text or regular-expression pattern used to match descriptions."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes match rule in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, pattern.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "pattern": "<pattern>"
        }
      }
    },
    {
      "name": "delete_match_rules",
      "title": "Delete Match Rules",
      "category": "Import, review, and reconciliation",
      "summary": "Deletes match rules in the local Clovis ledger.",
      "signature": "(rules: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "rules",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Match rules to create or apply."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes match rules in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: rules.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "rules": []
        }
      }
    },
    {
      "name": "delete_tag",
      "title": "Delete Tag",
      "category": "Configuration",
      "summary": "Deletes tag in the local Clovis ledger.",
      "signature": "(tag_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tag_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes tag in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tag_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "tag_id": "<tag_id>"
        }
      }
    },
    {
      "name": "delete_tags",
      "title": "Delete Tags",
      "category": "Configuration",
      "summary": "Deletes tags in the local Clovis ledger.",
      "signature": "(entity_type: string, entity_id: string, key?: string | null, val?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "entity_type",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "key",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "val",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Deletes tags in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: entity_type, entity_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "entity_type": "<entity_type>",
          "entity_id": "<entity_id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "delete_transaction",
      "title": "Delete Transaction",
      "category": "Ledger and accounts",
      "summary": "Deletes transaction in the local Clovis ledger.",
      "signature": "(id: string, hard_delete?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "hard_delete",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Permanently deletes rows instead of voiding them. Use only with explicit approval."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Deletes transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "id": "<id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "detect_recurring",
      "title": "Detect Recurring",
      "category": "Core tools",
      "summary": "Detects recurring activity in the local Clovis ledger.",
      "signature": "(months?: number, year?: number | null, month?: number | null, min_occurrences?: number, amount_tolerance_pct?: number, account_id?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "months",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 6,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "min_occurrences",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 2,
          "description": "Minimum repeated occurrences required before a pattern is reported."
        },
        {
          "name": "amount_tolerance_pct",
          "type": "number",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 5,
          "description": "Percent difference allowed when matching similar amounts."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Detects recurring activity in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "discard_batch",
      "title": "Discard Batch",
      "category": "Scenarios",
      "summary": "Discards batch in the local Clovis ledger.",
      "signature": "(tx_ids?: string[] | null, batch_id?: string | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tx_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of transaction ids."
        },
        {
          "name": "batch_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Import, commit, or mutation batch id."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Discards batch in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "discard_branch",
      "title": "Discard Branch",
      "category": "Scenarios",
      "summary": "Discards scenario branch in the local Clovis ledger.",
      "signature": "(name: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Discards scenario branch in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: name.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "name": "<name>"
        }
      }
    },
    {
      "name": "export_ledger",
      "title": "Export Ledger",
      "category": "Ledger and accounts",
      "summary": "Exports ledger in the local Clovis ledger.",
      "signature": "(output_path?: string | null, entity_id?: string | null, date_from?: string | null, date_to?: string | null, account_ids?: string[] | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "output_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local output path for a generated file or backup."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Exports ledger in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "export_transactions",
      "title": "Export Transactions",
      "category": "Ledger and accounts",
      "summary": "Exports transactions in the local Clovis ledger.",
      "signature": "(account_id?: string | null, date_from?: string | null, date_to?: string | null, status?: string | null, output_path?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "output_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local output path for a generated file or backup."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Exports transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "file_access_status",
      "title": "File Access Status",
      "category": "Core tools",
      "summary": "Shows file access status in the local Clovis ledger.",
      "signature": "() => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows file access status in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "financial_overview",
      "title": "Financial Overview",
      "category": "Core tools",
      "summary": "Returns a compact financial summary for the selected period and quote asset.",
      "signature": "(year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "active",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Returns a compact financial summary for the selected period and quote asset.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "financial_picture",
      "title": "Financial Picture",
      "category": "Core tools",
      "summary": "Returns a broader snapshot of balances, spending, pending items, and planned activity.",
      "signature": "(year?: number | null, month?: number | null, quote_asset_id: string, status?: string | null, include_pending?: boolean, include_planned?: boolean, entity_id?: string | null, account_ids?: string[] | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, earmarks?: Array<Record<string, unknown>> | null, include_open_items?: boolean, open_item_limit?: number, include_summary_markdown?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "include_planned",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes planned transactions in the calculation."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "asset_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset account ids to include in a projection."
        },
        {
          "name": "liability_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of identifiers from the local Clovis ledger."
        },
        {
          "name": "earmarks",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "include_open_items",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "open_item_limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 25,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "include_summary_markdown",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Returns a broader snapshot of balances, spending, pending items, and planned activity.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "find_pending_duplicates",
      "title": "Find Pending Duplicates",
      "category": "Import, review, and reconciliation",
      "summary": "Finds pending duplicates in the local Clovis ledger.",
      "signature": "(account_id?: string | null, date_from?: string | null, date_to?: string | null, date_tolerance_days?: number) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Finds pending duplicates in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "find_realized_planned",
      "title": "Find Realized Planned",
      "category": "Core tools",
      "summary": "Finds realized planned in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, account_ids?: string[] | null, asset_id?: string | null, date_tolerance_days?: number) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Finds realized planned in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "flip_entries",
      "title": "Flip Entries",
      "category": "Core tools",
      "summary": "Flips journal entries in the local Clovis ledger.",
      "signature": "(tx_ids: string[], dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tx_ids",
          "type": "string[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "List of transaction ids."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Flips journal entries in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tx_ids.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "tx_ids": [
            "<tx_ids>"
          ]
        }
      }
    },
    {
      "name": "forecast",
      "title": "Forecast",
      "category": "Planning and cash flow",
      "summary": "Forecasts forecast in the local Clovis ledger.",
      "signature": "(account_id: string, as_of?: string | null, asset_id?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "as_of",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Forecasts forecast in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "forecast_month_end",
      "title": "Forecast Month End",
      "category": "Planning and cash flow",
      "summary": "Forecasts month end in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, status?: string | null, include_pending?: boolean, include_planned?: boolean, planned_match_tolerance_days?: number, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "include_planned",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes planned transactions in the calculation."
        },
        {
          "name": "planned_match_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Forecasts month end in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "fx_transfer",
      "title": "Fx Transfer",
      "category": "Assets and investments",
      "summary": "Runs foreign exchange transfer in the local Clovis ledger.",
      "signature": "(from_account_id: string, to_account_id: string, from_amount: number, to_amount: number, from_asset_id: string, to_asset_id: string, fx_account_id: string, date: string, description: string, status?: string, record_rate?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "from_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for a transaction or transfer."
        },
        {
          "name": "to_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Destination account id for a transaction or transfer."
        },
        {
          "name": "from_amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "to_amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "from_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "to_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "fx_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "record_rate",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Runs foreign exchange transfer in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: from_account_id, to_account_id, from_amount, to_amount, from_asset_id, to_asset_id, fx_account_id, date, ....",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "from_account_id": "<from_account_id>",
          "to_account_id": "<to_account_id>",
          "from_amount": 100,
          "to_amount": 100,
          "from_asset_id": "USD",
          "to_asset_id": "USD",
          "fx_account_id": "<fx_account_id>",
          "date": "2026-06-01",
          "description": "<description>"
        }
      }
    },
    {
      "name": "get_account",
      "title": "Get Account",
      "category": "Ledger and accounts",
      "summary": "Shows account in the local Clovis ledger.",
      "signature": "(id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows account in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "id": "<id>"
        }
      }
    },
    {
      "name": "get_account_by_name",
      "title": "Get Account By Name",
      "category": "Ledger and accounts",
      "summary": "Shows account by name in the local Clovis ledger.",
      "signature": "(name: string) => Record<string, unknown> | null",
      "returns": {
        "type": "object",
        "nullable": true
      },
      "parameters": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows account by name in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: name."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "name": "<name>"
        }
      }
    },
    {
      "name": "get_asset_by_symbol",
      "title": "Get Asset By Symbol",
      "category": "Assets and investments",
      "summary": "Shows asset by symbol in the local Clovis ledger.",
      "signature": "(symbol: string) => Record<string, unknown> | null",
      "returns": {
        "type": "object",
        "nullable": true
      },
      "parameters": [
        {
          "name": "symbol",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows asset by symbol in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: symbol."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "symbol": "<symbol>"
        }
      }
    },
    {
      "name": "get_balance",
      "title": "Get Balance",
      "category": "Ledger and accounts",
      "summary": "Shows balance in the local Clovis ledger.",
      "signature": "(account_id: string, asset_id?: string | null, date?: string | null, status?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows balance in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "get_ledger_operation",
      "title": "Get Ledger Operation",
      "category": "Ledger and accounts",
      "summary": "Shows ledger operation in the local Clovis ledger.",
      "signature": "(operation_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "operation_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows ledger operation in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: operation_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "operation_id": "<operation_id>"
        }
      }
    },
    {
      "name": "get_price",
      "title": "Get Price",
      "category": "Assets and investments",
      "summary": "Shows price in the local Clovis ledger.",
      "signature": "(asset_id: string, quote_id: string, as_of: string) => Record<string, unknown> | null",
      "returns": {
        "type": "object",
        "nullable": true
      },
      "parameters": [
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "quote_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "as_of",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        }
      ],
      "aliases": {
        "quote_asset_id": "quote_id",
        "quote": "quote_id",
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows price in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id, quote_id, as_of."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD",
          "quote_id": "USD",
          "as_of": "2026-06-01"
        }
      }
    },
    {
      "name": "get_transaction",
      "title": "Get Transaction",
      "category": "Ledger and accounts",
      "summary": "Shows transaction in the local Clovis ledger.",
      "signature": "(id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "id": "<id>"
        }
      }
    },
    {
      "name": "goal_progress",
      "title": "Goal Progress",
      "category": "Planning and cash flow",
      "summary": "Runs goal progress in the local Clovis ledger.",
      "signature": "(account: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account name or id to inspect."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Runs goal progress in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account": "<account>"
        }
      }
    },
    {
      "name": "holdings",
      "title": "Holdings",
      "category": "Assets and investments",
      "summary": "Shows holdings in the local Clovis ledger.",
      "signature": "(account_id?: string | null, asset_type?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "asset_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency or asset symbol/id."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows holdings in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "import_file",
      "title": "Import File",
      "category": "Import, review, and reconciliation",
      "summary": "Imports a statement file into an account while preserving review-oriented metadata.",
      "signature": "(file_path: string, account_id: string, counterpart_account_id: string, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, status?: string, amount_convention?: string, show_duplicates?: boolean, statement_type?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "counterpart_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column that maps rows to counterpart accounts."
        },
        {
          "name": "tag_cols",
          "type": "object",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Mapping of statement columns to tags."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "show_duplicates",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Imports a statement file into an account while preserving review-oriented metadata.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "file_path": "./statement.csv",
          "account_id": "<account_id>",
          "counterpart_account_id": "<counterpart_account_id>"
        }
      }
    },
    {
      "name": "import_ledger",
      "title": "Import Ledger",
      "category": "Ledger and accounts",
      "summary": "Imports ledger in the local Clovis ledger.",
      "signature": "(file_path?: string | null, data?: string | null, preserve_ids?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "data",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "preserve_ids",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "List of identifiers from the local Clovis ledger."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Imports ledger in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "import_transactions",
      "title": "Import Transactions",
      "category": "Ledger and accounts",
      "summary": "Imports transactions in the local Clovis ledger.",
      "signature": "(account_id: string, counterpart_id: string, transactions: Array<Record<string, unknown>>, status?: string, dry_run?: boolean, batch_label?: string | null, tags?: Record<string, unknown> | null, amount_convention?: string, date_tolerance_days?: number, asset_id?: string | null, skip_dedup?: boolean, statement_type?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "transactions",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "batch_label",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human label attached to the generated batch."
        },
        {
          "name": "tags",
          "type": "object",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Metadata tags to attach."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 1,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "skip_dedup",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Skips duplicate detection. Use only when the user has already reviewed the rows."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Imports transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, counterpart_id, transactions.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "counterpart_id": "<counterpart_id>",
          "transactions": [],
          "dry_run": true
        }
      }
    },
    {
      "name": "income_statement",
      "title": "Income Statement",
      "category": "Import, review, and reconciliation",
      "summary": "Builds income statement in the local Clovis ledger.",
      "signature": "(year: number, month?: number | null, branch?: string | null, compact?: boolean, include_pending?: boolean, account_ids?: string[] | null, entity_id?: string | null, quote_asset_id: string, status?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Returns a smaller response shape when true."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Builds income statement in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: year, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "year": 1,
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "init_defaults",
      "title": "Init Defaults",
      "category": "Core tools",
      "summary": "Initializes defaults in the local Clovis ledger.",
      "signature": "(template?: string, currency: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "template",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "personal",
          "description": "Input used by this tool."
        },
        {
          "name": "currency",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Initializes defaults in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: currency.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "currency": "USD"
        }
      }
    },
    {
      "name": "inspect_transaction",
      "title": "Inspect Transaction",
      "category": "Ledger and accounts",
      "summary": "Inspects transaction in the local Clovis ledger.",
      "signature": "(tx_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tx_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Transaction id."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Inspects transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tx_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "tx_id": "<tx_id>"
        }
      }
    },
    {
      "name": "integrity_check",
      "title": "Integrity Check",
      "category": "Maintenance and safety",
      "summary": "Checks the ledger for structural or accounting problems before an agent changes anything.",
      "signature": "() => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Checks the ledger for structural or accounting problems before an agent changes anything.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it before or after risky operations to back up, inspect, or repair the ledger."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "invert_import",
      "title": "Invert Import",
      "category": "Import, review, and reconciliation",
      "summary": "Inverts import in the local Clovis ledger.",
      "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "batch_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Import, commit, or mutation batch id."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Inverts import in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: batch_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "batch_id": "<batch_id>"
        }
      }
    },
    {
      "name": "list_accounts",
      "title": "List Accounts",
      "category": "Ledger and accounts",
      "summary": "Lists accounts in the local Clovis ledger.",
      "signature": "(type?: string | null, parent_id?: string | null, include_counts?: boolean, tree?: boolean) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "parent_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Parent account id."
        },
        {
          "name": "include_counts",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "tree",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists accounts in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_assets",
      "title": "List Assets",
      "category": "Assets and investments",
      "summary": "Lists assets in the local Clovis ledger.",
      "signature": "(asset_type?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "asset_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency or asset symbol/id."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists assets in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_backups",
      "title": "List Backups",
      "category": "Maintenance and safety",
      "summary": "Lists backups in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists backups in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it before or after risky operations to back up, inspect, or repair the ledger."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_branches",
      "title": "List Branches",
      "category": "Scenarios",
      "summary": "Lists scenario branches in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists scenario branches in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_checkpoints",
      "title": "List Checkpoints",
      "category": "Core tools",
      "summary": "Lists period checkpoints in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists period checkpoints in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_entries",
      "title": "List Entries",
      "category": "Core tools",
      "summary": "Lists journal entries in the local Clovis ledger.",
      "signature": "(tx_id: string) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "tx_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Transaction id."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists journal entries in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tx_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "tx_id": "<tx_id>"
        }
      }
    },
    {
      "name": "list_entries_by_asset",
      "title": "List Entries By Asset",
      "category": "Assets and investments",
      "summary": "Lists journal entries by asset in the local Clovis ledger.",
      "signature": "(asset_id: string, limit?: number, offset?: number) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 100,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists journal entries by asset in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD"
        }
      }
    },
    {
      "name": "list_goals",
      "title": "List Goals",
      "category": "Planning and cash flow",
      "summary": "Lists goals in the local Clovis ledger.",
      "signature": "() => unknown[]",
      "returns": {
        "type": "array"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists goals in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns array from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_import_batches",
      "title": "List Import Batches",
      "category": "Import, review, and reconciliation",
      "summary": "Lists import batches in the local Clovis ledger.",
      "signature": "(limit?: number, date_from?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 20,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists import batches in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_ledger_operations",
      "title": "List Ledger Operations",
      "category": "Ledger and accounts",
      "summary": "Lists ledger operations in the local Clovis ledger.",
      "signature": "(limit?: number) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 50,
          "description": "Maximum number of rows to return."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists ledger operations in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_match_rules",
      "title": "List Match Rules",
      "category": "Import, review, and reconciliation",
      "summary": "Lists match rules in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists match rules in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_prices",
      "title": "List Prices",
      "category": "Assets and investments",
      "summary": "Lists prices in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists prices in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_scheduled",
      "title": "List Scheduled",
      "category": "Core tools",
      "summary": "Lists scheduled transactions in the local Clovis ledger.",
      "signature": "() => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists scheduled transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_tags",
      "title": "List Tags",
      "category": "Configuration",
      "summary": "Lists tags in the local Clovis ledger.",
      "signature": "(entity_type: string, entity_id: string) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "entity_type",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Entity id to filter reports when entity tracking is used."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists tags in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: entity_type, entity_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "entity_type": "<entity_type>",
          "entity_id": "<entity_id>"
        }
      }
    },
    {
      "name": "list_transactions",
      "title": "List Transactions",
      "category": "Ledger and accounts",
      "summary": "Lists transactions in the local Clovis ledger.",
      "signature": "(account_id?: string | null, category_id?: string | null, asset_id?: string | null, year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, status?: string | null, limit?: number, offset?: number, compact?: boolean, include_account_effects?: boolean, sort?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "category_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 50,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Returns a smaller response shape when true."
        },
        {
          "name": "include_account_effects",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "sort",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "date_desc",
          "description": "Sort order for returned rows."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_uncategorized",
      "title": "List Uncategorized",
      "category": "Import, review, and reconciliation",
      "summary": "Lists uncategorized transactions in the local Clovis ledger.",
      "signature": "(catch_all_account_id?: string | null, status?: string, date_from?: string | null, date_to?: string | null, limit?: number, offset?: number, compact?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "catch_all_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Fallback category account for rows that do not match a rule."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 50,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        },
        {
          "name": "compact",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Returns a smaller response shape when true."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists uncategorized transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "list_unmatched_transfers",
      "title": "List Unmatched Transfers",
      "category": "Import, review, and reconciliation",
      "summary": "Lists unmatched transfers in the local Clovis ledger.",
      "signature": "(date_tolerance_days?: number) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Lists unmatched transfers in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "match_transfer_pairs",
      "title": "Match Transfer Pairs",
      "category": "Import, review, and reconciliation",
      "summary": "Matches transfer pairs in the local Clovis ledger.",
      "signature": "(clearing_account?: string | null, account_a?: string | null, account_b?: string | null, date_from?: string | null, date_to?: string | null, date_tolerance_days?: number, match_by?: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "clearing_account",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "account_a",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "account_b",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "match_by",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "amount+date+code",
          "description": "Input used by this tool."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Matches transfer pairs in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "match_transfers",
      "title": "Match Transfers",
      "category": "Import, review, and reconciliation",
      "summary": "Matches transfers in the local Clovis ledger.",
      "signature": "(account_a: string, account_b: string, date_tolerance_days?: number, dry_run?: boolean, status?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_a",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "account_b",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 1,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Matches transfers in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_a, account_b.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_a": "<account_a>",
          "account_b": "<account_b>",
          "dry_run": true
        }
      }
    },
    {
      "name": "merge_accounts",
      "title": "Merge Accounts",
      "category": "Ledger and accounts",
      "summary": "Merges accounts in the local Clovis ledger.",
      "signature": "(sources: string[], target: string, delete_sources?: boolean, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "sources",
          "type": "string[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "target",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "delete_sources",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Merges accounts in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: sources, target.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "sources": [
            "<sources>"
          ],
          "target": "<target>"
        }
      }
    },
    {
      "name": "merge_branch",
      "title": "Merge Branch",
      "category": "Scenarios",
      "summary": "Merges scenario branch in the local Clovis ledger.",
      "signature": "(source: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "source",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Merges scenario branch in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when exploring or managing scenario branches separate from posted records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: source.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "source": "<source>"
        }
      }
    },
    {
      "name": "migrate_asset_entries",
      "title": "Migrate Asset Entries",
      "category": "Assets and investments",
      "summary": "Migrates asset journal entries in the local Clovis ledger.",
      "signature": "(from_asset_id: string, to_asset_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "from_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "to_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Migrates asset journal entries in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: from_asset_id, to_asset_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "from_asset_id": "USD",
          "to_asset_id": "USD",
          "dry_run": true
        }
      }
    },
    {
      "name": "move_transactions",
      "title": "Move Transactions",
      "category": "Ledger and accounts",
      "summary": "Moves transactions in the local Clovis ledger.",
      "signature": "(from_account: string, to_account: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "from_account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "to_account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Moves transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: from_account, to_account.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "from_account": "<from_account>",
          "to_account": "<to_account>",
          "dry_run": true
        }
      }
    },
    {
      "name": "net_worth",
      "title": "Net Worth",
      "category": "Reports",
      "summary": "Reports net worth in the local Clovis ledger.",
      "signature": "(date?: string | null, branch?: string | null, include_pending?: boolean, status?: string, quote_asset_id: string, account_ids?: string[] | null, entity_id?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "active",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reports net worth in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when the user asks for a finance report or period comparison."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "operating_manual",
      "title": "Operating Manual",
      "category": "Configuration",
      "summary": "Returns Clovis operating guidance for agents and humans.",
      "signature": "(topic?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "topic",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "all",
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Returns Clovis operating guidance for agents and humans.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "pending_summary",
      "title": "Pending Summary",
      "category": "Core tools",
      "summary": "Summarizes pending summary in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Summarizes pending summary in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "plan_transaction",
      "title": "Plan Transaction",
      "category": "Ledger and accounts",
      "summary": "Plans transaction in the local Clovis ledger.",
      "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description: string, branch?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "from_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for a transaction or transfer."
        },
        {
          "name": "to_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Destination account id for a transaction or transfer."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Plans transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, amount, from_account_id, to_account_id, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "amount": 100,
          "from_account_id": "<from_account_id>",
          "to_account_id": "<to_account_id>",
          "description": "<description>"
        }
      }
    },
    {
      "name": "post_journal_entry",
      "title": "Post Journal Entry",
      "category": "Ledger and accounts",
      "summary": "Posts journal journal entry in the local Clovis ledger.",
      "signature": "(date: string, legs: Array<Record<string, unknown>>, description: string, status?: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "legs",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Manual journal legs. Each leg identifies an account and amount."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Posts journal journal entry in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, legs, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "legs": [],
          "description": "<description>"
        }
      }
    },
    {
      "name": "preview_commit",
      "title": "Preview Commit",
      "category": "Import, review, and reconciliation",
      "summary": "Previews commit in the local Clovis ledger.",
      "signature": "(as_of?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "as_of",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date to calculate balances through, usually YYYY-MM-DD."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Previews commit in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "preview_import",
      "title": "Preview Import",
      "category": "Import, review, and reconciliation",
      "summary": "Parses a statement file and shows what Clovis would import before committing rows.",
      "signature": "(file_path: string, account_id: string, counterpart_account_id: string, rows?: number, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Rows to import, review, or mutate."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Parses a statement file and shows what Clovis would import before committing rows.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "file_path": "./statement.csv",
          "account_id": "<account_id>",
          "counterpart_account_id": "<counterpart_account_id>"
        }
      }
    },
    {
      "name": "preview_mutation",
      "title": "Preview Mutation",
      "category": "Import, review, and reconciliation",
      "summary": "Previews mutation in the local Clovis ledger.",
      "signature": "(tool_name: string, arguments?: Record<string, unknown>) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tool_name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "arguments",
          "type": "object",
          "required": false,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Previews mutation in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tool_name."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "tool_name": "<tool_name>"
        }
      }
    },
    {
      "name": "process_scheduled",
      "title": "Process Scheduled",
      "category": "Core tools",
      "summary": "Processes scheduled transactions in the local Clovis ledger.",
      "signature": "(through_date?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "through_date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Last date to process scheduled activity through."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Processes scheduled transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "process_statement",
      "title": "Process Statement",
      "category": "Import, review, and reconciliation",
      "summary": "Processes statement in the local Clovis ledger.",
      "signature": "(file_path: string, account_id: string, counterpart_account_id: string, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, transfer_account_id?: string | null, date_tolerance_days?: number, commit?: boolean, show_duplicates?: boolean, preview_rows?: number, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "expected_balance",
          "type": "number",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement ending balance expected after reconciliation."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "counterpart_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column that maps rows to counterpart accounts."
        },
        {
          "name": "tag_cols",
          "type": "object",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Mapping of statement columns to tags."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        },
        {
          "name": "balance_sign",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "transfer_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 1,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "commit",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "show_duplicates",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "preview_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 10,
          "description": "Numeric value used by this workflow."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Processes statement in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "file_path": "./statement.csv",
          "account_id": "<account_id>",
          "counterpart_account_id": "<counterpart_account_id>"
        }
      }
    },
    {
      "name": "project_balances",
      "title": "Project Balances",
      "category": "Ledger and accounts",
      "summary": "Projects balances in the local Clovis ledger.",
      "signature": "(through: string, account_ids?: string[] | null, include_goals?: boolean, branch?: string | null, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "through",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "include_goals",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Projects balances in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: through, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "through": "<through>",
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "project_month_end",
      "title": "Project Month End",
      "category": "Core tools",
      "summary": "Projects month end in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, expected_inflows?: Array<Record<string, unknown>> | null, expected_outflows?: Array<Record<string, unknown>> | null, expected_paychecks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, account_ids?: string[] | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "expected_inflows",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Expected incoming cash items for projection."
        },
        {
          "name": "expected_outflows",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Expected outgoing cash items for projection."
        },
        {
          "name": "expected_paychecks",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Expected paycheck or income items for projection."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "include_planned",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Includes planned transactions in the calculation."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "asset_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset account ids to include in a projection."
        },
        {
          "name": "liability_account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of identifiers from the local Clovis ledger."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Projects month end in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "query_effects",
      "title": "Query Effects",
      "category": "Core tools",
      "summary": "Returns semantic transaction effect lines for income, expenses, balance-sheet movement, transfers, refunds, corrections, and grouped reporting.",
      "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, status?: string | null, query?: string | null, account_id?: string | null, category_id?: string | null, account_type?: string | null, asset_id?: string | null, group_by?: string, limit?: number, offset?: number, sort?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": "active",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "query",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Case-insensitive description text to search for."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "category_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "account_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account type filter, such as asset, liability, equity, income, or expense."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "group_by",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "none",
          "description": "Optional grouping: none, journal, status, account, category, description_key, or month."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 100,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        },
        {
          "name": "sort",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "date_desc",
          "description": "Sort order for returned rows."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Returns semantic transaction effect lines for income, expenses, balance-sheet movement, transfers, refunds, corrections, and grouped reporting.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "recategorize_by_pattern",
      "title": "Recategorize By Pattern",
      "category": "Import, review, and reconciliation",
      "summary": "Recategorizes by pattern in the local Clovis ledger.",
      "signature": "(pattern: string, new_account_id: string, old_account_id?: string | null, date_from?: string | null, date_to?: string | null, dry_run?: boolean, persist_rule?: boolean, verbose?: boolean, status?: string, amount_min?: number | null, amount_max?: number | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "pattern",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Text or regular-expression pattern used to match descriptions."
        },
        {
          "name": "new_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "old_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "persist_rule",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Saves the pattern as a future match rule."
        },
        {
          "name": "verbose",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "amount_min",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "amount_max",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Recategorizes by pattern in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: pattern, new_account_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "pattern": "<pattern>",
          "new_account_id": "<new_account_id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "recategorize_by_patterns",
      "title": "Recategorize By Patterns",
      "category": "Import, review, and reconciliation",
      "summary": "Recategorizes by patterns in the local Clovis ledger.",
      "signature": "(rules: Array<Record<string, unknown>>, date_from?: string | null, date_to?: string | null, dry_run?: boolean, persist_rules?: boolean, old_account_id?: string | null, verbose?: boolean, status?: string, amount_min?: number | null, amount_max?: number | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "rules",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Match rules to create or apply."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "persist_rules",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "old_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "verbose",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "amount_min",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "amount_max",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Recategorizes by patterns in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: rules.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "rules": [],
          "dry_run": true
        }
      }
    },
    {
      "name": "recategorize_transaction",
      "title": "Recategorize Transaction",
      "category": "Ledger and accounts",
      "summary": "Recategorizes transaction in the local Clovis ledger.",
      "signature": "(tx_id: string, new_account_id: string, old_account_id?: string | null, correction_date?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "tx_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Transaction id."
        },
        {
          "name": "new_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "old_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "correction_date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date value, usually in YYYY-MM-DD format."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Recategorizes transaction in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: tx_id, new_account_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "tx_id": "<tx_id>",
          "new_account_id": "<new_account_id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "recognize_gain_loss",
      "title": "Recognize Gain Loss",
      "category": "Core tools",
      "summary": "Records gain loss in the local Clovis ledger.",
      "signature": "(date: string, amount: number, investment_account_id: string, description: string, gain_loss_account_id?: string | null, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "investment_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Investment account receiving or holding the security."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "gain_loss_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account used to record realized gains or losses."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records gain loss in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, amount, investment_account_id, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "amount": 100,
          "investment_account_id": "<investment_account_id>",
          "description": "<description>"
        }
      }
    },
    {
      "name": "reconcile_diff",
      "title": "Reconcile Diff",
      "category": "Import, review, and reconciliation",
      "summary": "Reconciles difference in the local Clovis ledger.",
      "signature": "(account_id: string, date_from?: string | null, date_to?: string | null, branch?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reconciles difference in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "reconcile_planned",
      "title": "Reconcile Planned",
      "category": "Import, review, and reconciliation",
      "summary": "Reconciles planned in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, account_ids?: string[] | null, asset_id?: string | null, date_tolerance_days?: number, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Reconciles planned in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "reconcile_statement",
      "title": "Reconcile Statement",
      "category": "Import, review, and reconciliation",
      "summary": "Reconciles statement in the local Clovis ledger.",
      "signature": "(account_id: string, counterpart_id: string, transactions: Array<Record<string, unknown>>, currency?: string | null, asset_id?: string | null, amount_convention?: string, statement_type?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "transactions",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reconciles statement in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, counterpart_id, transactions."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "counterpart_id": "<counterpart_id>",
          "transactions": []
        }
      }
    },
    {
      "name": "reconcile_statement_plan",
      "title": "Reconcile Statement Plan",
      "category": "Import, review, and reconciliation",
      "summary": "Builds a statement reconciliation plan without immediately applying it.",
      "signature": "(file_path: string, account_id: string, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, min_likely_score?: number, sample_limit?: number, include_details?: boolean, verbosity?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "file_path",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "expected_balance",
          "type": "number",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement ending balance expected after reconciliation."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        },
        {
          "name": "balance_sign",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "min_likely_score",
          "type": "number",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0.72,
          "description": "Minimum confidence score for accepting likely reconciliation matches."
        },
        {
          "name": "sample_limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 20,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "include_details",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "verbosity",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Builds a statement reconciliation plan without immediately applying it.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: file_path, account_id.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "file_path": "./statement.csv",
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "reconcile_to_balance",
      "title": "Reconcile To Balance",
      "category": "Ledger and accounts",
      "summary": "Reconciles to balance in the local Clovis ledger.",
      "signature": "(account_id: string, target_balance: number, offset_account_id: string, date: string, description?: string | null, asset_id?: string | null, status?: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "target_balance",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "offset_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "description",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reconciles to balance in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, target_balance, offset_account_id, date.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "target_balance": 1,
          "offset_account_id": "<offset_account_id>",
          "date": "2026-06-01",
          "dry_run": true
        }
      }
    },
    {
      "name": "record_investment",
      "title": "Record Investment",
      "category": "Assets and investments",
      "summary": "Records investment in the local Clovis ledger.",
      "signature": "(date: string, amount: number, investment_account_id: string, source_account_id: string, description: string, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "investment_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Investment account receiving or holding the security."
        },
        {
          "name": "source_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for funds, cash, or holdings."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records investment in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: date, amount, investment_account_id, source_account_id, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "date": "2026-06-01",
          "amount": 100,
          "investment_account_id": "<investment_account_id>",
          "source_account_id": "<source_account_id>",
          "description": "<description>"
        }
      }
    },
    {
      "name": "record_opening_balance",
      "title": "Record Opening Balance",
      "category": "Ledger and accounts",
      "summary": "Records opening balance in the local Clovis ledger.",
      "signature": "(account_id: string, amount: number, date: string, status?: string, asset_id?: string | null, counterpart_account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Offsetting account used for imported rows or generated transactions."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records opening balance in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, amount, date.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "amount": 100,
          "date": "2026-06-01"
        }
      }
    },
    {
      "name": "record_opening_balances",
      "title": "Record Opening Balances",
      "category": "Ledger and accounts",
      "summary": "Records opening balances in the local Clovis ledger.",
      "signature": "(balances: Array<Record<string, unknown>>, date: string, status?: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "balances",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "pending",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records opening balances in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: balances, date.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "balances": [],
          "date": "2026-06-01"
        }
      }
    },
    {
      "name": "record_pending_expenses",
      "title": "Record Pending Expenses",
      "category": "Core tools",
      "summary": "Records pending expenses in the local Clovis ledger.",
      "signature": "(account_id: string, transactions: Array<Record<string, unknown>>, counterpart_id?: string | null, asset_id?: string | null, batch_label?: string | null, tags?: Record<string, unknown> | null, dry_run?: boolean, skip_dedup?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "transactions",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "counterpart_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "batch_label",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human label attached to the generated batch."
        },
        {
          "name": "tags",
          "type": "object",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Metadata tags to attach."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "skip_dedup",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Skips duplicate detection. Use only when the user has already reviewed the rows."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Records pending expenses in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id, transactions.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>",
          "transactions": [],
          "dry_run": true
        }
      }
    },
    {
      "name": "refresh_statement",
      "title": "Refresh Statement",
      "category": "Import, review, and reconciliation",
      "summary": "Refreshes statement in the local Clovis ledger.",
      "signature": "(action?: string, plan_id?: string | null, file_path?: string | null, account_id?: string | null, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, row_indexes?: number[] | null, pending_transactions?: Array<Record<string, unknown>> | null, void_stale_pending?: boolean, status?: string, dry_run?: boolean, batch_label?: string | null, sample_limit?: number, include_details?: boolean, verbosity?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "action",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "plan",
          "description": "Input used by this tool."
        },
        {
          "name": "plan_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Previously generated plan id."
        },
        {
          "name": "file_path",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Local file path made available to Clovis."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "counterpart_account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Offsetting account used for imported rows or generated transactions."
        },
        {
          "name": "expected_balance",
          "type": "number",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement ending balance expected after reconciliation."
        },
        {
          "name": "currency",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Currency symbol when the file or workflow needs an explicit currency."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "date_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing transaction dates."
        },
        {
          "name": "amount_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing signed amounts."
        },
        {
          "name": "desc_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing merchant or transaction descriptions."
        },
        {
          "name": "inflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing incoming amounts."
        },
        {
          "name": "outflow_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column containing outgoing amounts."
        },
        {
          "name": "counterpart_col",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement column that maps rows to counterpart accounts."
        },
        {
          "name": "tag_cols",
          "type": "object",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Mapping of statement columns to tags."
        },
        {
          "name": "skip_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of header rows to ignore at the start of a statement file."
        },
        {
          "name": "skip_footer_rows",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of footer rows to ignore at the end of a statement file."
        },
        {
          "name": "date_format",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "auto",
          "description": "Statement date parser format, or auto for automatic parsing."
        },
        {
          "name": "amount_convention",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "signed",
          "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
        },
        {
          "name": "statement_type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Optional statement type hint, such as checking, credit card, or brokerage."
        },
        {
          "name": "balance_sign",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "date_tolerance_days",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Number of days a candidate match may differ by."
        },
        {
          "name": "row_indexes",
          "type": "integer[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Statement row indexes to apply or inspect."
        },
        {
          "name": "pending_transactions",
          "type": "object[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "void_stale_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "batch_label",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human label attached to the generated batch."
        },
        {
          "name": "sample_limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 20,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "include_details",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "verbosity",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Refreshes statement in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
          "Use it only for local files the user has intentionally made available to Clovis."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "reopen_period",
      "title": "Reopen Period",
      "category": "Core tools",
      "summary": "Reopens period in the local Clovis ledger.",
      "signature": "(checkpoint_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "checkpoint_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Period checkpoint id to reopen."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reopens period in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: checkpoint_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "checkpoint_id": "<checkpoint_id>"
        }
      }
    },
    {
      "name": "repair_integrity",
      "title": "Repair Integrity",
      "category": "Maintenance and safety",
      "summary": "Repairs integrity in the local Clovis ledger.",
      "signature": "(dry_run?: boolean, backup?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "backup",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Repairs integrity in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it before or after risky operations to back up, inspect, or repair the ledger."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    },
    {
      "name": "reverse_ledger_operation",
      "title": "Reverse Ledger Operation",
      "category": "Ledger and accounts",
      "summary": "Runs reverse ledger operation in the local Clovis ledger.",
      "signature": "(operation_id: string, date?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "operation_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Identifier from the local Clovis ledger."
        },
        {
          "name": "date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Runs reverse ledger operation in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: operation_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "operation_id": "<operation_id>",
          "dry_run": true
        }
      }
    },
    {
      "name": "rollback_import",
      "title": "Rollback Import",
      "category": "Import, review, and reconciliation",
      "summary": "Rolls back import in the local Clovis ledger.",
      "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "batch_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Import, commit, or mutation batch id."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Rolls back import in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: batch_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "batch_id": "<batch_id>"
        }
      }
    },
    {
      "name": "rollback_recategorize",
      "title": "Rollback Recategorize",
      "category": "Import, review, and reconciliation",
      "summary": "Rolls back recategorize in the local Clovis ledger.",
      "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "batch_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Import, commit, or mutation batch id."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Rolls back recategorize in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: batch_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "batch_id": "<batch_id>"
        }
      }
    },
    {
      "name": "search_transactions",
      "title": "Search Transactions",
      "category": "Ledger and accounts",
      "summary": "Searches transactions in the local Clovis ledger.",
      "signature": "(desc?: string | null, query?: string | null, amount_min?: number | null, amount_max?: number | null, account_id?: string | null, status?: string | null, date_from?: string | null, date_to?: string | null, posted_at_from?: string | null, posted_at_to?: string | null, limit?: number, offset?: number, include_account_effects?: boolean, sort?: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "desc",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "query",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Case-insensitive description text to search for."
        },
        {
          "name": "amount_min",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "amount_max",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Money or quantity value in the relevant asset."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "posted_at_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "posted_at_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 50,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "offset",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 0,
          "description": "Number of rows to skip before returning results."
        },
        {
          "name": "include_account_effects",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Account selected from the local chart of accounts."
        },
        {
          "name": "sort",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "date_desc",
          "description": "Sort order for returned rows."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Searches transactions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "set_budget",
      "title": "Set Budget",
      "category": "Planning and cash flow",
      "summary": "Sets budget in the local Clovis ledger.",
      "signature": "(account: string, amount: number, period?: string, year?: number | null, month?: number | null, rollover?: boolean, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account name or id to inspect."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "period",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "monthly",
          "description": "Input used by this tool."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "rollover",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Sets budget in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account, amount.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account": "<account>",
          "amount": 100
        }
      }
    },
    {
      "name": "set_budgets",
      "title": "Set Budgets",
      "category": "Planning and cash flow",
      "summary": "Sets budgets in the local Clovis ledger.",
      "signature": "(budgets: Array<Record<string, unknown>>, year?: number | null, month?: number | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "budgets",
          "type": "object[]",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Sets budgets in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: budgets.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "budgets": []
        }
      }
    },
    {
      "name": "set_goal",
      "title": "Set Goal",
      "category": "Planning and cash flow",
      "summary": "Sets goal in the local Clovis ledger.",
      "signature": "(account: string, target: number, name: string, target_date?: string | null, priority?: number, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Account name or id to inspect."
        },
        {
          "name": "target",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "name",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable name to create or update."
        },
        {
          "name": "target_date",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Date value, usually in YYYY-MM-DD format."
        },
        {
          "name": "priority",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 1,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Sets goal in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account, target, name.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "account": "<account>",
          "target": 1,
          "name": "<name>"
        }
      }
    },
    {
      "name": "spending",
      "title": "Spending",
      "category": "Reports",
      "summary": "Reports spending in the local Clovis ledger.",
      "signature": "(year: number, month: number, branch?: string | null, include_pending?: boolean, status?: string | null, account_ids?: string[] | null, entity_id?: string | null, quote_asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "include_pending",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Includes pending transactions in the calculation."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "account_ids",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "List of ledger account ids or account references."
        },
        {
          "name": "entity_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Entity id to filter reports when entity tracking is used."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reports spending in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when the user asks for a finance report or period comparison."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: year, month, quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "year": 1,
          "month": 6,
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "spending_rate",
      "title": "Spending Rate",
      "category": "Reports",
      "summary": "Calculates spending rate in the local Clovis ledger.",
      "signature": "(account?: string | null, year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "account",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Account name or id to inspect."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Calculates spending rate in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when the user asks for a finance report or period comparison."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "suggest_budgets",
      "title": "Suggest Budgets",
      "category": "Planning and cash flow",
      "summary": "Suggests budgets in the local Clovis ledger.",
      "signature": "(months?: number, year?: number | null, month?: number | null, skip_budgeted?: boolean, quote_asset_id: string) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "months",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 3,
          "description": "Numeric value used by this workflow."
        },
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "skip_budgeted",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Suggests budgets in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "tool_registry",
      "title": "Tool Registry",
      "category": "Configuration",
      "summary": "Returns the available public tools, signatures, and safety metadata.",
      "signature": "(names?: string[] | null, summary?: boolean, safety_filter?: string | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "names",
          "type": "string[]",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "summary",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Boolean switch for this workflow."
        },
        {
          "name": "safety_filter",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Returns the available public tools, signatures, and safety metadata.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {}
      }
    },
    {
      "name": "top_descriptions",
      "title": "Top Descriptions",
      "category": "Core tools",
      "summary": "Shows descriptions in the local Clovis ledger.",
      "signature": "(account_id: string, limit?: number, status?: string | null) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "limit",
          "type": "integer",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": 50,
          "description": "Maximum number of rows to return."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        }
      ],
      "aliases": {},
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Shows descriptions in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: account_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "account_id": "<account_id>"
        }
      }
    },
    {
      "name": "transfer",
      "title": "Transfer",
      "category": "Core tools",
      "summary": "Records transfer in the local Clovis ledger.",
      "signature": "(from_account_id: string, to_account_id: string, amount: number, date: string, description: string, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "from_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Source account id for a transaction or transfer."
        },
        {
          "name": "to_account_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Destination account id for a transaction or transfer."
        },
        {
          "name": "amount",
          "type": "number",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Money or quantity amount in the selected asset."
        },
        {
          "name": "date",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Ledger date in YYYY-MM-DD format."
        },
        {
          "name": "description",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Human-readable transaction, account, rule, or journal description."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Records transfer in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: from_account_id, to_account_id, amount, date, description.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "from_account_id": "<from_account_id>",
          "to_account_id": "<to_account_id>",
          "amount": 100,
          "date": "2026-06-01",
          "description": "<description>"
        }
      }
    },
    {
      "name": "trial_balance",
      "title": "Trial Balance",
      "category": "Ledger and accounts",
      "summary": "Builds trial balance in the local Clovis ledger.",
      "signature": "(branch?: string | null, status?: string | null, asset_id: string) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "branch",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Scenario branch name or id."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Builds trial balance in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD"
        }
      }
    },
    {
      "name": "unbudgeted_spending",
      "title": "Unbudgeted Spending",
      "category": "Planning and cash flow",
      "summary": "Reports spending in the local Clovis ledger.",
      "signature": "(year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Array<Record<string, unknown>>",
      "returns": {
        "type": "object[]"
      },
      "parameters": [
        {
          "name": "year",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Four-digit year."
        },
        {
          "name": "month",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Month number from 1 to 12."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": "posted",
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "quote_asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency used to quote report values. Clovis does not infer this."
        }
      ],
      "aliases": {
        "currency": "quote_asset_id",
        "quote": "quote_asset_id",
        "quote_id": "quote_asset_id"
      },
      "readOnly": true,
      "destructive": false,
      "dryRun": false,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": true,
        "destructiveHint": false,
        "idempotentHint": true,
        "openWorldHint": false,
        "supportsDryRun": false,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Reports spending in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
          "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: quote_asset_id.",
          "Choose the report currency or asset explicitly; Clovis does not infer report currency."
        ],
        "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
        "returns": "Returns object[] from the local ledger.",
        "exampleArguments": {
          "quote_asset_id": "USD"
        }
      }
    },
    {
      "name": "update_account",
      "title": "Update Account",
      "category": "Ledger and accounts",
      "summary": "Updates account in the local Clovis ledger.",
      "signature": "(id: string, name?: string | null, type?: string | null, code?: string | null, parent_id?: string | null, color_hex?: string | null, default_asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Input used by this tool."
        },
        {
          "name": "name",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human-readable name to create or update."
        },
        {
          "name": "type",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "code",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "parent_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Parent account id."
        },
        {
          "name": "color_hex",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Display color for the account or asset."
        },
        {
          "name": "default_asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Identifier from the local Clovis ledger."
        }
      ],
      "aliases": {},
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Updates account in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it when working with accounts, transactions, balances, registers, or double-entry records."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "id": "<id>"
        }
      }
    },
    {
      "name": "update_asset",
      "title": "Update Asset",
      "category": "Assets and investments",
      "summary": "Updates asset in the local Clovis ledger.",
      "signature": "(asset_id: string, symbol?: string | null, name?: string | null, dry_run?: boolean) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "asset_id",
          "type": "string",
          "required": true,
          "nullable": false,
          "variadic": false,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "symbol",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "name",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Human-readable name to create or update."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": false,
      "dryRun": true,
      "defaultDryRun": false,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": false,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": false
      },
      "docs": {
        "summary": "Updates asset in the local Clovis ledger.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it.",
          "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
        ],
        "beforeCalling": [
          "Have exact values for required inputs: asset_id.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "State the intended ledger change in plain language before calling the tool."
        ],
        "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "asset_id": "USD"
        }
      }
    },
    {
      "name": "void_by_filter",
      "title": "Void By Filter",
      "category": "Core tools",
      "summary": "Voids or hard-deletes transactions matching a filter, with dry-run enabled by default.",
      "signature": "(date_from?: string | null, date_to?: string | null, account_id?: string | null, status?: string | null, asset_id?: string | null, posted_at_from?: string | null, posted_at_to?: string | null, dry_run?: boolean, hard_delete?: boolean, sample_limit?: number | null) => Record<string, unknown>",
      "returns": {
        "type": "object"
      },
      "parameters": [
        {
          "name": "date_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Start date filter in YYYY-MM-DD format."
        },
        {
          "name": "date_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "End date filter in YYYY-MM-DD format."
        },
        {
          "name": "account_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Ledger account id or resolvable account reference."
        },
        {
          "name": "status",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Transaction status filter or value: posted, pending, planned, or void."
        },
        {
          "name": "asset_id",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Asset or currency id used by the ledger."
        },
        {
          "name": "posted_at_from",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "posted_at_to",
          "type": "string",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Input used by this tool."
        },
        {
          "name": "dry_run",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": true,
          "description": "Preview the result without committing changes."
        },
        {
          "name": "hard_delete",
          "type": "boolean",
          "required": false,
          "nullable": false,
          "variadic": false,
          "default": false,
          "description": "Permanently deletes rows instead of voiding them. Use only with explicit approval."
        },
        {
          "name": "sample_limit",
          "type": "integer",
          "required": false,
          "nullable": true,
          "variadic": false,
          "default": null,
          "description": "Numeric value used by this workflow."
        }
      ],
      "aliases": {
        "asset": "asset_id"
      },
      "readOnly": false,
      "destructive": true,
      "dryRun": true,
      "defaultDryRun": true,
      "annotations": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false
      },
      "safety": {
        "readOnlyHint": false,
        "destructiveHint": true,
        "idempotentHint": false,
        "openWorldHint": false,
        "supportsDryRun": true,
        "defaultDryRun": true
      },
      "docs": {
        "summary": "Voids or hard-deletes transactions matching a filter, with dry-run enabled by default.",
        "useWhen": [
          "Use it when an agent needs to prepare a change and show a preview before committing it."
        ],
        "beforeCalling": [
          "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
          "Start with dry_run=true, show the preview, then ask before applying the change.",
          "Create or confirm a backup and get explicit approval before running it for real."
        ],
        "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
        "returns": "Returns object from the local ledger.",
        "exampleArguments": {
          "dry_run": true
        }
      }
    }
  ],
  "toolGroups": [
    {
      "category": "Core tools",
      "tools": [
        {
          "name": "age_of_money",
          "title": "Age Of Money",
          "category": "Core tools",
          "summary": "Estimates age of money in the local Clovis ledger.",
          "signature": "(days?: number, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 30,
              "description": "Number of days to include in the calculation."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Estimates age of money in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "apply_pattern",
          "title": "Apply Pattern",
          "category": "Core tools",
          "summary": "Recategorizes transactions that match a description pattern, optionally saving the pattern as a rule.",
          "signature": "(pattern: string, target_account: string, force?: boolean, persist_rule?: boolean, dry_run?: boolean, source_account?: string | null, date_from?: string | null, date_to?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "pattern",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Text or regular-expression pattern used to match descriptions."
            },
            {
              "name": "target_account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Target category or account for the matched rows."
            },
            {
              "name": "force",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Allows the operation to continue through conflicts that would otherwise stop it."
            },
            {
              "name": "persist_rule",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Saves the pattern as a future match rule."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "source_account",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional source account filter."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Recategorizes transactions that match a description pattern, optionally saving the pattern as a rule.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: pattern, target_account.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "pattern": "<pattern>",
              "target_account": "<target_account>",
              "dry_run": true
            }
          }
        },
        {
          "name": "apply_reconciliation_plan",
          "title": "Apply Reconciliation Plan",
          "category": "Core tools",
          "summary": "Applies a prepared statement reconciliation plan, usually after reviewing the proposed matches and imports.",
          "signature": "(file_path?: string | null, plan_id?: string | null, account_id?: string | null, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, min_likely_score?: number, row_indexes?: number[] | null, commit_imported?: boolean, annotate_posted_matches?: boolean, allow_review_skip?: boolean, require_balance_match?: boolean, sample_limit?: number, include_details?: boolean, verbosity?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "plan_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Previously generated plan id."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "expected_balance",
              "type": "number",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement ending balance expected after reconciliation."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            },
            {
              "name": "balance_sign",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "min_likely_score",
              "type": "number",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0.72,
              "description": "Minimum confidence score for accepting likely reconciliation matches."
            },
            {
              "name": "row_indexes",
              "type": "integer[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement row indexes to apply or inspect."
            },
            {
              "name": "commit_imported",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "annotate_posted_matches",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Adds match annotations to already-posted transactions when applying the plan."
            },
            {
              "name": "allow_review_skip",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Allows the workflow to proceed even when review items remain."
            },
            {
              "name": "require_balance_match",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Requires the final balance to match the statement expectation."
            },
            {
              "name": "sample_limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 20,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "include_details",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "verbosity",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Applies a prepared statement reconciliation plan, usually after reviewing the proposed matches and imports.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "apply_rollover",
          "title": "Apply Rollover",
          "category": "Core tools",
          "summary": "Applies rollover in the local Clovis ledger.",
          "signature": "(year: number, month: number, quote_asset_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Applies rollover in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: year, month, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "year": 1,
              "month": 6,
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "close_period",
          "title": "Close Period",
          "category": "Core tools",
          "summary": "Closes period in the local Clovis ledger.",
          "signature": "(name: string, as_of: string, description?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            },
            {
              "name": "as_of",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            },
            {
              "name": "description",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human-readable transaction, account, rule, or journal description."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Closes period in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: name, as_of.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "name": "<name>",
              "as_of": "2026-06-01"
            }
          }
        },
        {
          "name": "commit_batch",
          "title": "Commit Batch",
          "category": "Core tools",
          "summary": "Commits batch in the local Clovis ledger.",
          "signature": "(tx_ids?: string[] | null, batch_id?: string | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tx_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of transaction ids."
            },
            {
              "name": "batch_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Import, commit, or mutation batch id."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Commits batch in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "consolidate_transfers",
          "title": "Consolidate Transfers",
          "category": "Core tools",
          "summary": "Consolidates transfers in the local Clovis ledger.",
          "signature": "(account_a: string, account_b: string, transfer_account_id?: string | null, date_tolerance_days?: number, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_a",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "account_b",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "transfer_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 1,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Consolidates transfers in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_a, account_b.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_a": "<account_a>",
              "account_b": "<account_b>",
              "dry_run": true
            }
          }
        },
        {
          "name": "detect_recurring",
          "title": "Detect Recurring",
          "category": "Core tools",
          "summary": "Detects recurring activity in the local Clovis ledger.",
          "signature": "(months?: number, year?: number | null, month?: number | null, min_occurrences?: number, amount_tolerance_pct?: number, account_id?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "months",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 6,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "min_occurrences",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 2,
              "description": "Minimum repeated occurrences required before a pattern is reported."
            },
            {
              "name": "amount_tolerance_pct",
              "type": "number",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 5,
              "description": "Percent difference allowed when matching similar amounts."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Detects recurring activity in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "file_access_status",
          "title": "File Access Status",
          "category": "Core tools",
          "summary": "Shows file access status in the local Clovis ledger.",
          "signature": "() => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows file access status in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "financial_overview",
          "title": "Financial Overview",
          "category": "Core tools",
          "summary": "Returns a compact financial summary for the selected period and quote asset.",
          "signature": "(year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "active",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Returns a compact financial summary for the selected period and quote asset.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "financial_picture",
          "title": "Financial Picture",
          "category": "Core tools",
          "summary": "Returns a broader snapshot of balances, spending, pending items, and planned activity.",
          "signature": "(year?: number | null, month?: number | null, quote_asset_id: string, status?: string | null, include_pending?: boolean, include_planned?: boolean, entity_id?: string | null, account_ids?: string[] | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, earmarks?: Array<Record<string, unknown>> | null, include_open_items?: boolean, open_item_limit?: number, include_summary_markdown?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "include_planned",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes planned transactions in the calculation."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "asset_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset account ids to include in a projection."
            },
            {
              "name": "liability_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of identifiers from the local Clovis ledger."
            },
            {
              "name": "earmarks",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "include_open_items",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "open_item_limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 25,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "include_summary_markdown",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Returns a broader snapshot of balances, spending, pending items, and planned activity.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "find_realized_planned",
          "title": "Find Realized Planned",
          "category": "Core tools",
          "summary": "Finds realized planned in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, account_ids?: string[] | null, asset_id?: string | null, date_tolerance_days?: number) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Finds realized planned in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "flip_entries",
          "title": "Flip Entries",
          "category": "Core tools",
          "summary": "Flips journal entries in the local Clovis ledger.",
          "signature": "(tx_ids: string[], dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tx_ids",
              "type": "string[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "List of transaction ids."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Flips journal entries in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tx_ids.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "tx_ids": [
                "<tx_ids>"
              ]
            }
          }
        },
        {
          "name": "init_defaults",
          "title": "Init Defaults",
          "category": "Core tools",
          "summary": "Initializes defaults in the local Clovis ledger.",
          "signature": "(template?: string, currency: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "template",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "personal",
              "description": "Input used by this tool."
            },
            {
              "name": "currency",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Initializes defaults in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: currency.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "currency": "USD"
            }
          }
        },
        {
          "name": "list_checkpoints",
          "title": "List Checkpoints",
          "category": "Core tools",
          "summary": "Lists period checkpoints in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists period checkpoints in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_entries",
          "title": "List Entries",
          "category": "Core tools",
          "summary": "Lists journal entries in the local Clovis ledger.",
          "signature": "(tx_id: string) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "tx_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Transaction id."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists journal entries in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tx_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "tx_id": "<tx_id>"
            }
          }
        },
        {
          "name": "list_scheduled",
          "title": "List Scheduled",
          "category": "Core tools",
          "summary": "Lists scheduled transactions in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists scheduled transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "pending_summary",
          "title": "Pending Summary",
          "category": "Core tools",
          "summary": "Summarizes pending summary in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Summarizes pending summary in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "process_scheduled",
          "title": "Process Scheduled",
          "category": "Core tools",
          "summary": "Processes scheduled transactions in the local Clovis ledger.",
          "signature": "(through_date?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "through_date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Last date to process scheduled activity through."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Processes scheduled transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "project_month_end",
          "title": "Project Month End",
          "category": "Core tools",
          "summary": "Projects month end in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, expected_inflows?: Array<Record<string, unknown>> | null, expected_outflows?: Array<Record<string, unknown>> | null, expected_paychecks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, account_ids?: string[] | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "expected_inflows",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Expected incoming cash items for projection."
            },
            {
              "name": "expected_outflows",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Expected outgoing cash items for projection."
            },
            {
              "name": "expected_paychecks",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Expected paycheck or income items for projection."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "include_planned",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes planned transactions in the calculation."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "asset_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset account ids to include in a projection."
            },
            {
              "name": "liability_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of identifiers from the local Clovis ledger."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Projects month end in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "query_effects",
          "title": "Query Effects",
          "category": "Core tools",
          "summary": "Returns semantic transaction effect lines for income, expenses, balance-sheet movement, transfers, refunds, corrections, and grouped reporting.",
          "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, status?: string | null, query?: string | null, account_id?: string | null, category_id?: string | null, account_type?: string | null, asset_id?: string | null, group_by?: string, limit?: number, offset?: number, sort?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": "active",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "query",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Case-insensitive description text to search for."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "category_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "account_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account type filter, such as asset, liability, equity, income, or expense."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "group_by",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "none",
              "description": "Optional grouping: none, journal, status, account, category, description_key, or month."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 100,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            },
            {
              "name": "sort",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "date_desc",
              "description": "Sort order for returned rows."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Returns semantic transaction effect lines for income, expenses, balance-sheet movement, transfers, refunds, corrections, and grouped reporting.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "recognize_gain_loss",
          "title": "Recognize Gain Loss",
          "category": "Core tools",
          "summary": "Records gain loss in the local Clovis ledger.",
          "signature": "(date: string, amount: number, investment_account_id: string, description: string, gain_loss_account_id?: string | null, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "investment_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Investment account receiving or holding the security."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "gain_loss_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account used to record realized gains or losses."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records gain loss in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, amount, investment_account_id, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "amount": 100,
              "investment_account_id": "<investment_account_id>",
              "description": "<description>"
            }
          }
        },
        {
          "name": "record_pending_expenses",
          "title": "Record Pending Expenses",
          "category": "Core tools",
          "summary": "Records pending expenses in the local Clovis ledger.",
          "signature": "(account_id: string, transactions: Array<Record<string, unknown>>, counterpart_id?: string | null, asset_id?: string | null, batch_label?: string | null, tags?: Record<string, unknown> | null, dry_run?: boolean, skip_dedup?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "transactions",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "counterpart_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "batch_label",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human label attached to the generated batch."
            },
            {
              "name": "tags",
              "type": "object",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Metadata tags to attach."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "skip_dedup",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Skips duplicate detection. Use only when the user has already reviewed the rows."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Records pending expenses in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, transactions.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "transactions": [],
              "dry_run": true
            }
          }
        },
        {
          "name": "reopen_period",
          "title": "Reopen Period",
          "category": "Core tools",
          "summary": "Reopens period in the local Clovis ledger.",
          "signature": "(checkpoint_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "checkpoint_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Period checkpoint id to reopen."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reopens period in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: checkpoint_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "checkpoint_id": "<checkpoint_id>"
            }
          }
        },
        {
          "name": "top_descriptions",
          "title": "Top Descriptions",
          "category": "Core tools",
          "summary": "Shows descriptions in the local Clovis ledger.",
          "signature": "(account_id: string, limit?: number, status?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 50,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows descriptions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "transfer",
          "title": "Transfer",
          "category": "Core tools",
          "summary": "Records transfer in the local Clovis ledger.",
          "signature": "(from_account_id: string, to_account_id: string, amount: number, date: string, description: string, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "from_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for a transaction or transfer."
            },
            {
              "name": "to_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Destination account id for a transaction or transfer."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records transfer in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: from_account_id, to_account_id, amount, date, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "from_account_id": "<from_account_id>",
              "to_account_id": "<to_account_id>",
              "amount": 100,
              "date": "2026-06-01",
              "description": "<description>"
            }
          }
        },
        {
          "name": "void_by_filter",
          "title": "Void By Filter",
          "category": "Core tools",
          "summary": "Voids or hard-deletes transactions matching a filter, with dry-run enabled by default.",
          "signature": "(date_from?: string | null, date_to?: string | null, account_id?: string | null, status?: string | null, asset_id?: string | null, posted_at_from?: string | null, posted_at_to?: string | null, dry_run?: boolean, hard_delete?: boolean, sample_limit?: number | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "posted_at_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "posted_at_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "hard_delete",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Permanently deletes rows instead of voiding them. Use only with explicit approval."
            },
            {
              "name": "sample_limit",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Numeric value used by this workflow."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Voids or hard-deletes transactions matching a filter, with dry-run enabled by default.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        }
      ]
    },
    {
      "category": "Ledger and accounts",
      "tools": [
        {
          "name": "account_balances",
          "title": "Account Balances",
          "category": "Ledger and accounts",
          "summary": "Shows posted, pending, and current balances by account and asset.",
          "signature": "(account_type?: string | null, asset_id?: string | null, as_of?: string | null, rollup?: boolean, hide_zero?: boolean, native_asset_only?: boolean, presentation?: string, account_ids?: string[] | null, entity_id?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "account_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account type filter, such as asset, liability, equity, income, or expense."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "as_of",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            },
            {
              "name": "rollup",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "hide_zero",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Hides zero-balance rows from the response."
            },
            {
              "name": "native_asset_only",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Currency or asset symbol/id."
            },
            {
              "name": "presentation",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "ledger",
              "description": "Input used by this tool."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows posted, pending, and current balances by account and asset.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "account_register",
          "title": "Account Register",
          "category": "Ledger and accounts",
          "summary": "Shows the transaction register for one account, with date, status, branch, and pagination filters.",
          "signature": "(account_id: string, asset_id?: string | null, date_from?: string | null, date_to?: string | null, time_from?: string | null, time_to?: string | null, branch?: string | null, status?: string | null, limit?: number, offset?: number, summary?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "time_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start timestamp filter."
            },
            {
              "name": "time_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End timestamp filter."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 100,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            },
            {
              "name": "summary",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows the transaction register for one account, with date, status, branch, and pagination filters.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "assert_balance",
          "title": "Assert Balance",
          "category": "Ledger and accounts",
          "summary": "Checks balance in the local Clovis ledger.",
          "signature": "(account_id: string, expected: number, date?: string | null, asset_id?: string | null, status?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "expected",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Expected balance amount to compare with the ledger."
            },
            {
              "name": "date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Checks balance in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, expected."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "expected": 1
            }
          }
        },
        {
          "name": "assert_balances",
          "title": "Assert Balances",
          "category": "Ledger and accounts",
          "summary": "Checks balances in the local Clovis ledger.",
          "signature": "(assertions: unknown[], status?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "assertions",
              "type": "array",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Balance assertions to check against the ledger."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Checks balances in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: assertions."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "assertions": []
            }
          }
        },
        {
          "name": "balance_sheet",
          "title": "Balance Sheet",
          "category": "Ledger and accounts",
          "summary": "Builds an assets, liabilities, and equity report for a date or scenario branch.",
          "signature": "(date?: string | null, branch?: string | null, compact?: boolean, include_pending?: boolean, status?: string, hide_zero?: boolean, quote_asset_id: string, account_ids?: string[] | null, entity_id?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Returns a smaller response shape when true."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "active",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "hide_zero",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Hides zero-balance rows from the response."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Builds an assets, liabilities, and equity report for a date or scenario branch.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "count_transactions",
          "title": "Count Transactions",
          "category": "Ledger and accounts",
          "summary": "Counts transactions in the local Clovis ledger.",
          "signature": "(account_id?: string | null, status?: string | null, date_from?: string | null, date_to?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Counts transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "create_account",
          "title": "Create Account",
          "category": "Ledger and accounts",
          "summary": "Creates account in the local Clovis ledger.",
          "signature": "(name: string, type: string, code?: string, parent_id?: string | null, color_hex?: string, default_asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            },
            {
              "name": "type",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "code",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "",
              "description": "Input used by this tool."
            },
            {
              "name": "parent_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Parent account id."
            },
            {
              "name": "color_hex",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "#888888",
              "description": "Display color for the account or asset."
            },
            {
              "name": "default_asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates account in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: name, type.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "name": "<name>",
              "type": "<type>"
            }
          }
        },
        {
          "name": "create_accounts",
          "title": "Create Accounts",
          "category": "Ledger and accounts",
          "summary": "Creates accounts in the local Clovis ledger.",
          "signature": "(accounts: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "accounts",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates accounts in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: accounts.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "accounts": []
            }
          }
        },
        {
          "name": "create_scheduled_transaction",
          "title": "Create Scheduled Transaction",
          "category": "Ledger and accounts",
          "summary": "Creates scheduled transactions transaction in the local Clovis ledger.",
          "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description?: string, frequency?: string, end_date?: string | null, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "from_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for a transaction or transfer."
            },
            {
              "name": "to_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Destination account id for a transaction or transfer."
            },
            {
              "name": "description",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "",
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "frequency",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "monthly",
              "description": "Schedule frequency, such as monthly."
            },
            {
              "name": "end_date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Final date for a scheduled or recurring workflow."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates scheduled transactions transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, amount, from_account_id, to_account_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "amount": 100,
              "from_account_id": "<from_account_id>",
              "to_account_id": "<to_account_id>"
            }
          }
        },
        {
          "name": "create_transaction",
          "title": "Create Transaction",
          "category": "Ledger and accounts",
          "summary": "Creates transaction in the local Clovis ledger.",
          "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description: string, status?: string, asset_id?: string | null, branch?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "from_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for a transaction or transfer."
            },
            {
              "name": "to_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Destination account id for a transaction or transfer."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, amount, from_account_id, to_account_id, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "amount": 100,
              "from_account_id": "<from_account_id>",
              "to_account_id": "<to_account_id>",
              "description": "<description>"
            }
          }
        },
        {
          "name": "delete_account",
          "title": "Delete Account",
          "category": "Ledger and accounts",
          "summary": "Deletes account in the local Clovis ledger.",
          "signature": "(id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes account in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "id": "<id>"
            }
          }
        },
        {
          "name": "delete_transaction",
          "title": "Delete Transaction",
          "category": "Ledger and accounts",
          "summary": "Deletes transaction in the local Clovis ledger.",
          "signature": "(id: string, hard_delete?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "hard_delete",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Permanently deletes rows instead of voiding them. Use only with explicit approval."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "id": "<id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "export_ledger",
          "title": "Export Ledger",
          "category": "Ledger and accounts",
          "summary": "Exports ledger in the local Clovis ledger.",
          "signature": "(output_path?: string | null, entity_id?: string | null, date_from?: string | null, date_to?: string | null, account_ids?: string[] | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "output_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local output path for a generated file or backup."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Exports ledger in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "export_transactions",
          "title": "Export Transactions",
          "category": "Ledger and accounts",
          "summary": "Exports transactions in the local Clovis ledger.",
          "signature": "(account_id?: string | null, date_from?: string | null, date_to?: string | null, status?: string | null, output_path?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "output_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local output path for a generated file or backup."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Exports transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "get_account",
          "title": "Get Account",
          "category": "Ledger and accounts",
          "summary": "Shows account in the local Clovis ledger.",
          "signature": "(id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows account in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "id": "<id>"
            }
          }
        },
        {
          "name": "get_account_by_name",
          "title": "Get Account By Name",
          "category": "Ledger and accounts",
          "summary": "Shows account by name in the local Clovis ledger.",
          "signature": "(name: string) => Record<string, unknown> | null",
          "returns": {
            "type": "object",
            "nullable": true
          },
          "parameters": [
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows account by name in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: name."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "name": "<name>"
            }
          }
        },
        {
          "name": "get_balance",
          "title": "Get Balance",
          "category": "Ledger and accounts",
          "summary": "Shows balance in the local Clovis ledger.",
          "signature": "(account_id: string, asset_id?: string | null, date?: string | null, status?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows balance in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "get_ledger_operation",
          "title": "Get Ledger Operation",
          "category": "Ledger and accounts",
          "summary": "Shows ledger operation in the local Clovis ledger.",
          "signature": "(operation_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "operation_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows ledger operation in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: operation_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "operation_id": "<operation_id>"
            }
          }
        },
        {
          "name": "get_transaction",
          "title": "Get Transaction",
          "category": "Ledger and accounts",
          "summary": "Shows transaction in the local Clovis ledger.",
          "signature": "(id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "id": "<id>"
            }
          }
        },
        {
          "name": "import_ledger",
          "title": "Import Ledger",
          "category": "Ledger and accounts",
          "summary": "Imports ledger in the local Clovis ledger.",
          "signature": "(file_path?: string | null, data?: string | null, preserve_ids?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "data",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "preserve_ids",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "List of identifiers from the local Clovis ledger."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Imports ledger in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "import_transactions",
          "title": "Import Transactions",
          "category": "Ledger and accounts",
          "summary": "Imports transactions in the local Clovis ledger.",
          "signature": "(account_id: string, counterpart_id: string, transactions: Array<Record<string, unknown>>, status?: string, dry_run?: boolean, batch_label?: string | null, tags?: Record<string, unknown> | null, amount_convention?: string, date_tolerance_days?: number, asset_id?: string | null, skip_dedup?: boolean, statement_type?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "transactions",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "batch_label",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human label attached to the generated batch."
            },
            {
              "name": "tags",
              "type": "object",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Metadata tags to attach."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 1,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "skip_dedup",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Skips duplicate detection. Use only when the user has already reviewed the rows."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Imports transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, counterpart_id, transactions.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "counterpart_id": "<counterpart_id>",
              "transactions": [],
              "dry_run": true
            }
          }
        },
        {
          "name": "inspect_transaction",
          "title": "Inspect Transaction",
          "category": "Ledger and accounts",
          "summary": "Inspects transaction in the local Clovis ledger.",
          "signature": "(tx_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tx_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Transaction id."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Inspects transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tx_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "tx_id": "<tx_id>"
            }
          }
        },
        {
          "name": "list_accounts",
          "title": "List Accounts",
          "category": "Ledger and accounts",
          "summary": "Lists accounts in the local Clovis ledger.",
          "signature": "(type?: string | null, parent_id?: string | null, include_counts?: boolean, tree?: boolean) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "parent_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Parent account id."
            },
            {
              "name": "include_counts",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "tree",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists accounts in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_ledger_operations",
          "title": "List Ledger Operations",
          "category": "Ledger and accounts",
          "summary": "Lists ledger operations in the local Clovis ledger.",
          "signature": "(limit?: number) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 50,
              "description": "Maximum number of rows to return."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists ledger operations in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_transactions",
          "title": "List Transactions",
          "category": "Ledger and accounts",
          "summary": "Lists transactions in the local Clovis ledger.",
          "signature": "(account_id?: string | null, category_id?: string | null, asset_id?: string | null, year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, status?: string | null, limit?: number, offset?: number, compact?: boolean, include_account_effects?: boolean, sort?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "category_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 50,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Returns a smaller response shape when true."
            },
            {
              "name": "include_account_effects",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "sort",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "date_desc",
              "description": "Sort order for returned rows."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "merge_accounts",
          "title": "Merge Accounts",
          "category": "Ledger and accounts",
          "summary": "Merges accounts in the local Clovis ledger.",
          "signature": "(sources: string[], target: string, delete_sources?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "sources",
              "type": "string[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "target",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "delete_sources",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Merges accounts in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: sources, target.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "sources": [
                "<sources>"
              ],
              "target": "<target>"
            }
          }
        },
        {
          "name": "move_transactions",
          "title": "Move Transactions",
          "category": "Ledger and accounts",
          "summary": "Moves transactions in the local Clovis ledger.",
          "signature": "(from_account: string, to_account: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "from_account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "to_account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Moves transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: from_account, to_account.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "from_account": "<from_account>",
              "to_account": "<to_account>",
              "dry_run": true
            }
          }
        },
        {
          "name": "plan_transaction",
          "title": "Plan Transaction",
          "category": "Ledger and accounts",
          "summary": "Plans transaction in the local Clovis ledger.",
          "signature": "(date: string, amount: number, from_account_id: string, to_account_id: string, description: string, branch?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "from_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for a transaction or transfer."
            },
            {
              "name": "to_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Destination account id for a transaction or transfer."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Plans transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, amount, from_account_id, to_account_id, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "amount": 100,
              "from_account_id": "<from_account_id>",
              "to_account_id": "<to_account_id>",
              "description": "<description>"
            }
          }
        },
        {
          "name": "post_journal_entry",
          "title": "Post Journal Entry",
          "category": "Ledger and accounts",
          "summary": "Posts journal journal entry in the local Clovis ledger.",
          "signature": "(date: string, legs: Array<Record<string, unknown>>, description: string, status?: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "legs",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Manual journal legs. Each leg identifies an account and amount."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Posts journal journal entry in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, legs, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "legs": [],
              "description": "<description>"
            }
          }
        },
        {
          "name": "project_balances",
          "title": "Project Balances",
          "category": "Ledger and accounts",
          "summary": "Projects balances in the local Clovis ledger.",
          "signature": "(through: string, account_ids?: string[] | null, include_goals?: boolean, branch?: string | null, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "through",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "include_goals",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Projects balances in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: through, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "through": "<through>",
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "recategorize_transaction",
          "title": "Recategorize Transaction",
          "category": "Ledger and accounts",
          "summary": "Recategorizes transaction in the local Clovis ledger.",
          "signature": "(tx_id: string, new_account_id: string, old_account_id?: string | null, correction_date?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tx_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Transaction id."
            },
            {
              "name": "new_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "old_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "correction_date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date value, usually in YYYY-MM-DD format."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Recategorizes transaction in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tx_id, new_account_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "tx_id": "<tx_id>",
              "new_account_id": "<new_account_id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "reconcile_to_balance",
          "title": "Reconcile To Balance",
          "category": "Ledger and accounts",
          "summary": "Reconciles to balance in the local Clovis ledger.",
          "signature": "(account_id: string, target_balance: number, offset_account_id: string, date: string, description?: string | null, asset_id?: string | null, status?: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "target_balance",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "offset_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "description",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reconciles to balance in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, target_balance, offset_account_id, date.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "target_balance": 1,
              "offset_account_id": "<offset_account_id>",
              "date": "2026-06-01",
              "dry_run": true
            }
          }
        },
        {
          "name": "record_opening_balance",
          "title": "Record Opening Balance",
          "category": "Ledger and accounts",
          "summary": "Records opening balance in the local Clovis ledger.",
          "signature": "(account_id: string, amount: number, date: string, status?: string, asset_id?: string | null, counterpart_account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Offsetting account used for imported rows or generated transactions."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records opening balance in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, amount, date.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "amount": 100,
              "date": "2026-06-01"
            }
          }
        },
        {
          "name": "record_opening_balances",
          "title": "Record Opening Balances",
          "category": "Ledger and accounts",
          "summary": "Records opening balances in the local Clovis ledger.",
          "signature": "(balances: Array<Record<string, unknown>>, date: string, status?: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "balances",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records opening balances in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: balances, date.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "balances": [],
              "date": "2026-06-01"
            }
          }
        },
        {
          "name": "reverse_ledger_operation",
          "title": "Reverse Ledger Operation",
          "category": "Ledger and accounts",
          "summary": "Runs reverse ledger operation in the local Clovis ledger.",
          "signature": "(operation_id: string, date?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "operation_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Runs reverse ledger operation in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: operation_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "operation_id": "<operation_id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "search_transactions",
          "title": "Search Transactions",
          "category": "Ledger and accounts",
          "summary": "Searches transactions in the local Clovis ledger.",
          "signature": "(desc?: string | null, query?: string | null, amount_min?: number | null, amount_max?: number | null, account_id?: string | null, status?: string | null, date_from?: string | null, date_to?: string | null, posted_at_from?: string | null, posted_at_to?: string | null, limit?: number, offset?: number, include_account_effects?: boolean, sort?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "desc",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "query",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Case-insensitive description text to search for."
            },
            {
              "name": "amount_min",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "amount_max",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "posted_at_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "posted_at_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 50,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            },
            {
              "name": "include_account_effects",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "sort",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "date_desc",
              "description": "Sort order for returned rows."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Searches transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "trial_balance",
          "title": "Trial Balance",
          "category": "Ledger and accounts",
          "summary": "Builds trial balance in the local Clovis ledger.",
          "signature": "(branch?: string | null, status?: string | null, asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Builds trial balance in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD"
            }
          }
        },
        {
          "name": "update_account",
          "title": "Update Account",
          "category": "Ledger and accounts",
          "summary": "Updates account in the local Clovis ledger.",
          "signature": "(id: string, name?: string | null, type?: string | null, code?: string | null, parent_id?: string | null, color_hex?: string | null, default_asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "name",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human-readable name to create or update."
            },
            {
              "name": "type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "code",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "parent_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Parent account id."
            },
            {
              "name": "color_hex",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Display color for the account or asset."
            },
            {
              "name": "default_asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Updates account in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when working with accounts, transactions, balances, registers, or double-entry records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "id": "<id>"
            }
          }
        }
      ]
    },
    {
      "category": "Import, review, and reconciliation",
      "tools": [
        {
          "name": "add_match_rule",
          "title": "Add Match Rule",
          "category": "Import, review, and reconciliation",
          "summary": "Adds match rule in the local Clovis ledger.",
          "signature": "(account_id: string, pattern: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "pattern",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Text or regular-expression pattern used to match descriptions."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Adds match rule in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, pattern.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "pattern": "<pattern>"
            }
          }
        },
        {
          "name": "add_match_rules",
          "title": "Add Match Rules",
          "category": "Import, review, and reconciliation",
          "summary": "Adds match rules in the local Clovis ledger.",
          "signature": "(rules: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "rules",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Match rules to create or apply."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Adds match rules in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: rules.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "rules": []
            }
          }
        },
        {
          "name": "apply_match_rules",
          "title": "Apply Match Rules",
          "category": "Import, review, and reconciliation",
          "summary": "Applies saved categorization rules to pending transactions, with dry-run on by default.",
          "signature": "(catch_all_account_id: string, date_from?: string | null, date_to?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "catch_all_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Fallback category account for rows that do not match a rule."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Applies saved categorization rules to pending transactions, with dry-run on by default.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: catch_all_account_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "catch_all_account_id": "<catch_all_account_id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "audit_categorization",
          "title": "Audit Categorization",
          "category": "Import, review, and reconciliation",
          "summary": "Audits categorization in the local Clovis ledger.",
          "signature": "(date_from?: string | null, date_to?: string | null, catch_all_account_id?: string | null, min_occurrences?: number, status?: string, mode?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "catch_all_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Fallback category account for rows that do not match a rule."
            },
            {
              "name": "min_occurrences",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 2,
              "description": "Minimum repeated occurrences required before a pattern is reported."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "mode",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "budget",
              "description": "Workflow mode used by the tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Audits categorization in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "budget_rollover_preview",
          "title": "Budget Rollover Preview",
          "category": "Import, review, and reconciliation",
          "summary": "Runs budget rollover preview in the local Clovis ledger.",
          "signature": "(year: number, month: number, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Runs budget rollover preview in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: year, month, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "year": 1,
              "month": 6,
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "delete_match_rule",
          "title": "Delete Match Rule",
          "category": "Import, review, and reconciliation",
          "summary": "Deletes match rule in the local Clovis ledger.",
          "signature": "(account_id: string, pattern: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "pattern",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Text or regular-expression pattern used to match descriptions."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes match rule in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, pattern.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "pattern": "<pattern>"
            }
          }
        },
        {
          "name": "delete_match_rules",
          "title": "Delete Match Rules",
          "category": "Import, review, and reconciliation",
          "summary": "Deletes match rules in the local Clovis ledger.",
          "signature": "(rules: Array<Record<string, unknown>>, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "rules",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Match rules to create or apply."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes match rules in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: rules.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "rules": []
            }
          }
        },
        {
          "name": "find_pending_duplicates",
          "title": "Find Pending Duplicates",
          "category": "Import, review, and reconciliation",
          "summary": "Finds pending duplicates in the local Clovis ledger.",
          "signature": "(account_id?: string | null, date_from?: string | null, date_to?: string | null, date_tolerance_days?: number) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Finds pending duplicates in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "import_file",
          "title": "Import File",
          "category": "Import, review, and reconciliation",
          "summary": "Imports a statement file into an account while preserving review-oriented metadata.",
          "signature": "(file_path: string, account_id: string, counterpart_account_id: string, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, status?: string, amount_convention?: string, show_duplicates?: boolean, statement_type?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "counterpart_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column that maps rows to counterpart accounts."
            },
            {
              "name": "tag_cols",
              "type": "object",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Mapping of statement columns to tags."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "show_duplicates",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Imports a statement file into an account while preserving review-oriented metadata.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "file_path": "./statement.csv",
              "account_id": "<account_id>",
              "counterpart_account_id": "<counterpart_account_id>"
            }
          }
        },
        {
          "name": "income_statement",
          "title": "Income Statement",
          "category": "Import, review, and reconciliation",
          "summary": "Builds income statement in the local Clovis ledger.",
          "signature": "(year: number, month?: number | null, branch?: string | null, compact?: boolean, include_pending?: boolean, account_ids?: string[] | null, entity_id?: string | null, quote_asset_id: string, status?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Returns a smaller response shape when true."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Builds income statement in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: year, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "year": 1,
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "invert_import",
          "title": "Invert Import",
          "category": "Import, review, and reconciliation",
          "summary": "Inverts import in the local Clovis ledger.",
          "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "batch_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Import, commit, or mutation batch id."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Inverts import in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: batch_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "batch_id": "<batch_id>"
            }
          }
        },
        {
          "name": "list_import_batches",
          "title": "List Import Batches",
          "category": "Import, review, and reconciliation",
          "summary": "Lists import batches in the local Clovis ledger.",
          "signature": "(limit?: number, date_from?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 20,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists import batches in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_match_rules",
          "title": "List Match Rules",
          "category": "Import, review, and reconciliation",
          "summary": "Lists match rules in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists match rules in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_uncategorized",
          "title": "List Uncategorized",
          "category": "Import, review, and reconciliation",
          "summary": "Lists uncategorized transactions in the local Clovis ledger.",
          "signature": "(catch_all_account_id?: string | null, status?: string, date_from?: string | null, date_to?: string | null, limit?: number, offset?: number, compact?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "catch_all_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Fallback category account for rows that do not match a rule."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 50,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Returns a smaller response shape when true."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists uncategorized transactions in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_unmatched_transfers",
          "title": "List Unmatched Transfers",
          "category": "Import, review, and reconciliation",
          "summary": "Lists unmatched transfers in the local Clovis ledger.",
          "signature": "(date_tolerance_days?: number) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists unmatched transfers in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "match_transfer_pairs",
          "title": "Match Transfer Pairs",
          "category": "Import, review, and reconciliation",
          "summary": "Matches transfer pairs in the local Clovis ledger.",
          "signature": "(clearing_account?: string | null, account_a?: string | null, account_b?: string | null, date_from?: string | null, date_to?: string | null, date_tolerance_days?: number, match_by?: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "clearing_account",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "account_a",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "account_b",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "match_by",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "amount+date+code",
              "description": "Input used by this tool."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Matches transfer pairs in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "match_transfers",
          "title": "Match Transfers",
          "category": "Import, review, and reconciliation",
          "summary": "Matches transfers in the local Clovis ledger.",
          "signature": "(account_a: string, account_b: string, date_tolerance_days?: number, dry_run?: boolean, status?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_a",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "account_b",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 1,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "pending",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Matches transfers in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_a, account_b.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_a": "<account_a>",
              "account_b": "<account_b>",
              "dry_run": true
            }
          }
        },
        {
          "name": "preview_commit",
          "title": "Preview Commit",
          "category": "Import, review, and reconciliation",
          "summary": "Previews commit in the local Clovis ledger.",
          "signature": "(as_of?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "as_of",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Previews commit in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "preview_import",
          "title": "Preview Import",
          "category": "Import, review, and reconciliation",
          "summary": "Parses a statement file and shows what Clovis would import before committing rows.",
          "signature": "(file_path: string, account_id: string, counterpart_account_id: string, rows?: number, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Rows to import, review, or mutate."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Parses a statement file and shows what Clovis would import before committing rows.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "file_path": "./statement.csv",
              "account_id": "<account_id>",
              "counterpart_account_id": "<counterpart_account_id>"
            }
          }
        },
        {
          "name": "preview_mutation",
          "title": "Preview Mutation",
          "category": "Import, review, and reconciliation",
          "summary": "Previews mutation in the local Clovis ledger.",
          "signature": "(tool_name: string, arguments?: Record<string, unknown>) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tool_name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "arguments",
              "type": "object",
              "required": false,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Previews mutation in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tool_name."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "tool_name": "<tool_name>"
            }
          }
        },
        {
          "name": "process_statement",
          "title": "Process Statement",
          "category": "Import, review, and reconciliation",
          "summary": "Processes statement in the local Clovis ledger.",
          "signature": "(file_path: string, account_id: string, counterpart_account_id: string, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, transfer_account_id?: string | null, date_tolerance_days?: number, commit?: boolean, show_duplicates?: boolean, preview_rows?: number, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "expected_balance",
              "type": "number",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement ending balance expected after reconciliation."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "counterpart_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column that maps rows to counterpart accounts."
            },
            {
              "name": "tag_cols",
              "type": "object",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Mapping of statement columns to tags."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            },
            {
              "name": "balance_sign",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "transfer_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 1,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "commit",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "show_duplicates",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "preview_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 10,
              "description": "Numeric value used by this workflow."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Processes statement in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: file_path, account_id, counterpart_account_id.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "file_path": "./statement.csv",
              "account_id": "<account_id>",
              "counterpart_account_id": "<counterpart_account_id>"
            }
          }
        },
        {
          "name": "recategorize_by_pattern",
          "title": "Recategorize By Pattern",
          "category": "Import, review, and reconciliation",
          "summary": "Recategorizes by pattern in the local Clovis ledger.",
          "signature": "(pattern: string, new_account_id: string, old_account_id?: string | null, date_from?: string | null, date_to?: string | null, dry_run?: boolean, persist_rule?: boolean, verbose?: boolean, status?: string, amount_min?: number | null, amount_max?: number | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "pattern",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Text or regular-expression pattern used to match descriptions."
            },
            {
              "name": "new_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "old_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "persist_rule",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Saves the pattern as a future match rule."
            },
            {
              "name": "verbose",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "amount_min",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "amount_max",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Recategorizes by pattern in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: pattern, new_account_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "pattern": "<pattern>",
              "new_account_id": "<new_account_id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "recategorize_by_patterns",
          "title": "Recategorize By Patterns",
          "category": "Import, review, and reconciliation",
          "summary": "Recategorizes by patterns in the local Clovis ledger.",
          "signature": "(rules: Array<Record<string, unknown>>, date_from?: string | null, date_to?: string | null, dry_run?: boolean, persist_rules?: boolean, old_account_id?: string | null, verbose?: boolean, status?: string, amount_min?: number | null, amount_max?: number | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "rules",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Match rules to create or apply."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "persist_rules",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "old_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "verbose",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "amount_min",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "amount_max",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Money or quantity value in the relevant asset."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Recategorizes by patterns in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: rules.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "rules": [],
              "dry_run": true
            }
          }
        },
        {
          "name": "reconcile_diff",
          "title": "Reconcile Diff",
          "category": "Import, review, and reconciliation",
          "summary": "Reconciles difference in the local Clovis ledger.",
          "signature": "(account_id: string, date_from?: string | null, date_to?: string | null, branch?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reconciles difference in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "reconcile_planned",
          "title": "Reconcile Planned",
          "category": "Import, review, and reconciliation",
          "summary": "Reconciles planned in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, account_ids?: string[] | null, asset_id?: string | null, date_tolerance_days?: number, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Reconciles planned in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "reconcile_statement",
          "title": "Reconcile Statement",
          "category": "Import, review, and reconciliation",
          "summary": "Reconciles statement in the local Clovis ledger.",
          "signature": "(account_id: string, counterpart_id: string, transactions: Array<Record<string, unknown>>, currency?: string | null, asset_id?: string | null, amount_convention?: string, statement_type?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "transactions",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reconciles statement in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, counterpart_id, transactions."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "counterpart_id": "<counterpart_id>",
              "transactions": []
            }
          }
        },
        {
          "name": "reconcile_statement_plan",
          "title": "Reconcile Statement Plan",
          "category": "Import, review, and reconciliation",
          "summary": "Builds a statement reconciliation plan without immediately applying it.",
          "signature": "(file_path: string, account_id: string, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, min_likely_score?: number, sample_limit?: number, include_details?: boolean, verbosity?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "file_path",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "expected_balance",
              "type": "number",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement ending balance expected after reconciliation."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            },
            {
              "name": "balance_sign",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "min_likely_score",
              "type": "number",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0.72,
              "description": "Minimum confidence score for accepting likely reconciliation matches."
            },
            {
              "name": "sample_limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 20,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "include_details",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "verbosity",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Builds a statement reconciliation plan without immediately applying it.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: file_path, account_id.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "file_path": "./statement.csv",
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "refresh_statement",
          "title": "Refresh Statement",
          "category": "Import, review, and reconciliation",
          "summary": "Refreshes statement in the local Clovis ledger.",
          "signature": "(action?: string, plan_id?: string | null, file_path?: string | null, account_id?: string | null, counterpart_account_id?: string | null, expected_balance?: number | null, currency?: string | null, asset_id?: string | null, date_col?: string | null, amount_col?: string | null, desc_col?: string | null, inflow_col?: string | null, outflow_col?: string | null, counterpart_col?: string | null, tag_cols?: Record<string, unknown> | null, skip_rows?: number, skip_footer_rows?: number, date_format?: string, amount_convention?: string, statement_type?: string | null, balance_sign?: string | null, date_tolerance_days?: number, row_indexes?: number[] | null, pending_transactions?: Array<Record<string, unknown>> | null, void_stale_pending?: boolean, status?: string, dry_run?: boolean, batch_label?: string | null, sample_limit?: number, include_details?: boolean, verbosity?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "action",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "plan",
              "description": "Input used by this tool."
            },
            {
              "name": "plan_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Previously generated plan id."
            },
            {
              "name": "file_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local file path made available to Clovis."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "counterpart_account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Offsetting account used for imported rows or generated transactions."
            },
            {
              "name": "expected_balance",
              "type": "number",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement ending balance expected after reconciliation."
            },
            {
              "name": "currency",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency symbol when the file or workflow needs an explicit currency."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "date_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing transaction dates."
            },
            {
              "name": "amount_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing signed amounts."
            },
            {
              "name": "desc_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing merchant or transaction descriptions."
            },
            {
              "name": "inflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing incoming amounts."
            },
            {
              "name": "outflow_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column containing outgoing amounts."
            },
            {
              "name": "counterpart_col",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement column that maps rows to counterpart accounts."
            },
            {
              "name": "tag_cols",
              "type": "object",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Mapping of statement columns to tags."
            },
            {
              "name": "skip_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of header rows to ignore at the start of a statement file."
            },
            {
              "name": "skip_footer_rows",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of footer rows to ignore at the end of a statement file."
            },
            {
              "name": "date_format",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "auto",
              "description": "Statement date parser format, or auto for automatic parsing."
            },
            {
              "name": "amount_convention",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "signed",
              "description": "How statement amounts should be interpreted, such as signed or inflow/outflow."
            },
            {
              "name": "statement_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Optional statement type hint, such as checking, credit card, or brokerage."
            },
            {
              "name": "balance_sign",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "date_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Number of days a candidate match may differ by."
            },
            {
              "name": "row_indexes",
              "type": "integer[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Statement row indexes to apply or inspect."
            },
            {
              "name": "pending_transactions",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "void_stale_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "batch_label",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human label attached to the generated batch."
            },
            {
              "name": "sample_limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 20,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "include_details",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "verbosity",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Refreshes statement in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "rollback_import",
          "title": "Rollback Import",
          "category": "Import, review, and reconciliation",
          "summary": "Rolls back import in the local Clovis ledger.",
          "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "batch_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Import, commit, or mutation batch id."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Rolls back import in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: batch_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "batch_id": "<batch_id>"
            }
          }
        },
        {
          "name": "rollback_recategorize",
          "title": "Rollback Recategorize",
          "category": "Import, review, and reconciliation",
          "summary": "Rolls back recategorize in the local Clovis ledger.",
          "signature": "(batch_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "batch_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Import, commit, or mutation batch id."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Rolls back recategorize in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it during statement import, duplicate review, matching, categorization, or reconciliation workflows."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: batch_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "batch_id": "<batch_id>"
            }
          }
        }
      ]
    },
    {
      "category": "Reports",
      "tools": [
        {
          "name": "net_worth",
          "title": "Net Worth",
          "category": "Reports",
          "summary": "Reports net worth in the local Clovis ledger.",
          "signature": "(date?: string | null, branch?: string | null, include_pending?: boolean, status?: string, quote_asset_id: string, account_ids?: string[] | null, entity_id?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "active",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reports net worth in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when the user asks for a finance report or period comparison."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "spending",
          "title": "Spending",
          "category": "Reports",
          "summary": "Reports spending in the local Clovis ledger.",
          "signature": "(year: number, month: number, branch?: string | null, include_pending?: boolean, status?: string | null, account_ids?: string[] | null, entity_id?: string | null, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of ledger account ids or account references."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reports spending in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when the user asks for a finance report or period comparison."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: year, month, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "year": 1,
              "month": 6,
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "spending_rate",
          "title": "Spending Rate",
          "category": "Reports",
          "summary": "Calculates spending rate in the local Clovis ledger.",
          "signature": "(account?: string | null, year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account name or id to inspect."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Calculates spending rate in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when the user asks for a finance report or period comparison."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        }
      ]
    },
    {
      "category": "Planning and cash flow",
      "tools": [
        {
          "name": "budget_status",
          "title": "Budget Status",
          "category": "Planning and cash flow",
          "summary": "Shows budget status in the local Clovis ledger.",
          "signature": "(account?: string | null, year?: number | null, month?: number | null, rollup?: boolean, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account name or id to inspect."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "rollup",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows budget status in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "budget_summary",
          "title": "Budget Summary",
          "category": "Planning and cash flow",
          "summary": "Summarizes budget summary in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Summarizes budget summary in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "cash_flow",
          "title": "Cash Flow",
          "category": "Planning and cash flow",
          "summary": "Reports cash flow in the local Clovis ledger.",
          "signature": "(year: number, month: number, branch?: string | null, compact?: boolean, include_pending?: boolean, status?: string, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "branch",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Scenario branch name or id."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Returns a smaller response shape when true."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reports cash flow in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: year, month, quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "year": 1,
              "month": 6,
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "cash_projection",
          "title": "Cash Projection",
          "category": "Planning and cash flow",
          "summary": "Projects cash projection in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, entity_id?: string | null, earmarks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, planned_match_tolerance_days?: number, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "asset_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset account ids to include in a projection."
            },
            {
              "name": "liability_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of identifiers from the local Clovis ledger."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "earmarks",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "include_planned",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes planned transactions in the calculation."
            },
            {
              "name": "planned_match_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Projects cash projection in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "cash_runway",
          "title": "Cash Runway",
          "category": "Planning and cash flow",
          "summary": "Estimates how long spendable cash can cover burn, based on the selected assumptions.",
          "signature": "(year?: number | null, month?: number | null, as_of?: string | null, asset_account_ids?: string[] | null, liability_account_ids?: string[] | null, earmarks?: Array<Record<string, unknown>> | null, include_pending?: boolean, include_planned?: boolean, include_partial_month?: boolean, reserve_remaining_budget?: boolean, include_sources?: boolean, summary?: boolean, trailing_months_short?: number, trailing_months_long?: number, discretionary_multiplier?: number, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "as_of",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            },
            {
              "name": "asset_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset account ids to include in a projection."
            },
            {
              "name": "liability_account_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of identifiers from the local Clovis ledger."
            },
            {
              "name": "earmarks",
              "type": "object[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "include_planned",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Includes planned transactions in the calculation."
            },
            {
              "name": "include_partial_month",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "reserve_remaining_budget",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "include_sources",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "summary",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "trailing_months_short",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "trailing_months_long",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 6,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "discretionary_multiplier",
              "type": "number",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0.5,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Estimates how long spendable cash can cover burn, based on the selected assumptions.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "copy_budgets",
          "title": "Copy Budgets",
          "category": "Planning and cash flow",
          "summary": "Copies budgets in the local Clovis ledger.",
          "signature": "(from_year: number, from_month: number, to_year: number, to_month: number, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "from_year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "from_month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "to_year",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "to_month",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Copies budgets in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: from_year, from_month, to_year, to_month.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "from_year": 1,
              "from_month": 1,
              "to_year": 1,
              "to_month": 1
            }
          }
        },
        {
          "name": "delete_budget",
          "title": "Delete Budget",
          "category": "Planning and cash flow",
          "summary": "Deletes budget in the local Clovis ledger.",
          "signature": "(account: string, year?: number | null, month?: number | null, include_overrides?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account name or id to inspect."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "include_overrides",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes budget in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account": "<account>"
            }
          }
        },
        {
          "name": "delete_budgets",
          "title": "Delete Budgets",
          "category": "Planning and cash flow",
          "summary": "Deletes budgets in the local Clovis ledger.",
          "signature": "(accounts?: string[] | null, year?: number | null, month?: number | null, include_overrides?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "accounts",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Account selected from the local chart of accounts."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "include_overrides",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes budgets in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "delete_goal",
          "title": "Delete Goal",
          "category": "Planning and cash flow",
          "summary": "Deletes goal in the local Clovis ledger.",
          "signature": "(account: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account name or id to inspect."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes goal in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account": "<account>"
            }
          }
        },
        {
          "name": "forecast",
          "title": "Forecast",
          "category": "Planning and cash flow",
          "summary": "Forecasts forecast in the local Clovis ledger.",
          "signature": "(account_id: string, as_of?: string | null, asset_id?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "as_of",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Forecasts forecast in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>"
            }
          }
        },
        {
          "name": "forecast_month_end",
          "title": "Forecast Month End",
          "category": "Planning and cash flow",
          "summary": "Forecasts month end in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, status?: string | null, include_pending?: boolean, include_planned?: boolean, planned_match_tolerance_days?: number, quote_asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "include_pending",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes pending transactions in the calculation."
            },
            {
              "name": "include_planned",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Includes planned transactions in the calculation."
            },
            {
              "name": "planned_match_tolerance_days",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Forecasts month end in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "goal_progress",
          "title": "Goal Progress",
          "category": "Planning and cash flow",
          "summary": "Runs goal progress in the local Clovis ledger.",
          "signature": "(account: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account name or id to inspect."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Runs goal progress in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account": "<account>"
            }
          }
        },
        {
          "name": "list_goals",
          "title": "List Goals",
          "category": "Planning and cash flow",
          "summary": "Lists goals in the local Clovis ledger.",
          "signature": "() => unknown[]",
          "returns": {
            "type": "array"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists goals in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns array from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "set_budget",
          "title": "Set Budget",
          "category": "Planning and cash flow",
          "summary": "Sets budget in the local Clovis ledger.",
          "signature": "(account: string, amount: number, period?: string, year?: number | null, month?: number | null, rollover?: boolean, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account name or id to inspect."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "period",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "monthly",
              "description": "Input used by this tool."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "rollover",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Sets budget in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account, amount.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account": "<account>",
              "amount": 100
            }
          }
        },
        {
          "name": "set_budgets",
          "title": "Set Budgets",
          "category": "Planning and cash flow",
          "summary": "Sets budgets in the local Clovis ledger.",
          "signature": "(budgets: Array<Record<string, unknown>>, year?: number | null, month?: number | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "budgets",
              "type": "object[]",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Sets budgets in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: budgets.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "budgets": []
            }
          }
        },
        {
          "name": "set_goal",
          "title": "Set Goal",
          "category": "Planning and cash flow",
          "summary": "Sets goal in the local Clovis ledger.",
          "signature": "(account: string, target: number, name: string, target_date?: string | null, priority?: number, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Account name or id to inspect."
            },
            {
              "name": "target",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            },
            {
              "name": "target_date",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Date value, usually in YYYY-MM-DD format."
            },
            {
              "name": "priority",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 1,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Sets goal in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account, target, name.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account": "<account>",
              "target": 1,
              "name": "<name>"
            }
          }
        },
        {
          "name": "suggest_budgets",
          "title": "Suggest Budgets",
          "category": "Planning and cash flow",
          "summary": "Suggests budgets in the local Clovis ledger.",
          "signature": "(months?: number, year?: number | null, month?: number | null, skip_budgeted?: boolean, quote_asset_id: string) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "months",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 3,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "skip_budgeted",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Suggests budgets in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        },
        {
          "name": "unbudgeted_spending",
          "title": "Unbudgeted Spending",
          "category": "Planning and cash flow",
          "summary": "Reports spending in the local Clovis ledger.",
          "signature": "(year?: number | null, month?: number | null, status?: string, quote_asset_id: string) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "year",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Four-digit year."
            },
            {
              "name": "month",
              "type": "integer",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Month number from 1 to 12."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "quote_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency used to quote report values. Clovis does not infer this."
            }
          ],
          "aliases": {
            "currency": "quote_asset_id",
            "quote": "quote_asset_id",
            "quote_id": "quote_asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Reports spending in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for budgets, goals, forecasts, month-end projections, runway, or cash planning."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: quote_asset_id.",
              "Choose the report currency or asset explicitly; Clovis does not infer report currency."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "quote_asset_id": "USD"
            }
          }
        }
      ]
    },
    {
      "category": "Assets and investments",
      "tools": [
        {
          "name": "buy_security",
          "title": "Buy Security",
          "category": "Assets and investments",
          "summary": "Records security in the local Clovis ledger.",
          "signature": "(account_id: string, symbol: string, shares: number, total_cost_cents: number, date: string, commission_cents?: number, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "symbol",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "shares",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "total_cost_cents",
              "type": "integer",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "commission_cents",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records security in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: account_id, symbol, shares, total_cost_cents, date.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "account_id": "<account_id>",
              "symbol": "<symbol>",
              "shares": 1,
              "total_cost_cents": 1,
              "date": "2026-06-01"
            }
          }
        },
        {
          "name": "create_asset",
          "title": "Create Asset",
          "category": "Assets and investments",
          "summary": "Creates asset in the local Clovis ledger.",
          "signature": "(symbol: string, asset_type?: string, decimals?: number, name?: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "symbol",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "asset_type",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "currency",
              "description": "Currency or asset symbol/id."
            },
            {
              "name": "decimals",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 2,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "name",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "",
              "description": "Human-readable name to create or update."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates asset in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: symbol.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "symbol": "<symbol>"
            }
          }
        },
        {
          "name": "create_price",
          "title": "Create Price",
          "category": "Assets and investments",
          "summary": "Creates price in the local Clovis ledger.",
          "signature": "(asset_id: string, quote_id: string, rate: number, time: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "quote_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "rate",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Numeric value used by this workflow."
            },
            {
              "name": "time",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {
            "quote_asset_id": "quote_id",
            "quote": "quote_id",
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates price in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id, quote_id, rate, time.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD",
              "quote_id": "USD",
              "rate": 1,
              "time": "<time>"
            }
          }
        },
        {
          "name": "delete_asset",
          "title": "Delete Asset",
          "category": "Assets and investments",
          "summary": "Deletes asset in the local Clovis ledger.",
          "signature": "(asset_id: string, force?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "force",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Allows the operation to continue through conflicts that would otherwise stop it."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes asset in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD"
            }
          }
        },
        {
          "name": "fx_transfer",
          "title": "Fx Transfer",
          "category": "Assets and investments",
          "summary": "Runs foreign exchange transfer in the local Clovis ledger.",
          "signature": "(from_account_id: string, to_account_id: string, from_amount: number, to_amount: number, from_asset_id: string, to_asset_id: string, fx_account_id: string, date: string, description: string, status?: string, record_rate?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "from_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for a transaction or transfer."
            },
            {
              "name": "to_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Destination account id for a transaction or transfer."
            },
            {
              "name": "from_amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "to_amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity value in the relevant asset."
            },
            {
              "name": "from_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "to_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "fx_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "record_rate",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Runs foreign exchange transfer in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: from_account_id, to_account_id, from_amount, to_amount, from_asset_id, to_asset_id, fx_account_id, date, ....",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "from_account_id": "<from_account_id>",
              "to_account_id": "<to_account_id>",
              "from_amount": 100,
              "to_amount": 100,
              "from_asset_id": "USD",
              "to_asset_id": "USD",
              "fx_account_id": "<fx_account_id>",
              "date": "2026-06-01",
              "description": "<description>"
            }
          }
        },
        {
          "name": "get_asset_by_symbol",
          "title": "Get Asset By Symbol",
          "category": "Assets and investments",
          "summary": "Shows asset by symbol in the local Clovis ledger.",
          "signature": "(symbol: string) => Record<string, unknown> | null",
          "returns": {
            "type": "object",
            "nullable": true
          },
          "parameters": [
            {
              "name": "symbol",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows asset by symbol in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: symbol."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "symbol": "<symbol>"
            }
          }
        },
        {
          "name": "get_price",
          "title": "Get Price",
          "category": "Assets and investments",
          "summary": "Shows price in the local Clovis ledger.",
          "signature": "(asset_id: string, quote_id: string, as_of: string) => Record<string, unknown> | null",
          "returns": {
            "type": "object",
            "nullable": true
          },
          "parameters": [
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "quote_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "as_of",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Date to calculate balances through, usually YYYY-MM-DD."
            }
          ],
          "aliases": {
            "quote_asset_id": "quote_id",
            "quote": "quote_id",
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows price in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id, quote_id, as_of."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD",
              "quote_id": "USD",
              "as_of": "2026-06-01"
            }
          }
        },
        {
          "name": "holdings",
          "title": "Holdings",
          "category": "Assets and investments",
          "summary": "Shows holdings in the local Clovis ledger.",
          "signature": "(account_id?: string | null, asset_type?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "asset_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency or asset symbol/id."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows holdings in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_assets",
          "title": "List Assets",
          "category": "Assets and investments",
          "summary": "Lists assets in the local Clovis ledger.",
          "signature": "(asset_type?: string | null) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "asset_type",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Currency or asset symbol/id."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists assets in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_entries_by_asset",
          "title": "List Entries By Asset",
          "category": "Assets and investments",
          "summary": "Lists journal entries by asset in the local Clovis ledger.",
          "signature": "(asset_id: string, limit?: number, offset?: number) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "limit",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 100,
              "description": "Maximum number of rows to return."
            },
            {
              "name": "offset",
              "type": "integer",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": 0,
              "description": "Number of rows to skip before returning results."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists journal entries by asset in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD"
            }
          }
        },
        {
          "name": "list_prices",
          "title": "List Prices",
          "category": "Assets and investments",
          "summary": "Lists prices in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists prices in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "migrate_asset_entries",
          "title": "Migrate Asset Entries",
          "category": "Assets and investments",
          "summary": "Migrates asset journal entries in the local Clovis ledger.",
          "signature": "(from_asset_id: string, to_asset_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "from_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "to_asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Migrates asset journal entries in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: from_asset_id, to_asset_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "from_asset_id": "USD",
              "to_asset_id": "USD",
              "dry_run": true
            }
          }
        },
        {
          "name": "record_investment",
          "title": "Record Investment",
          "category": "Assets and investments",
          "summary": "Records investment in the local Clovis ledger.",
          "signature": "(date: string, amount: number, investment_account_id: string, source_account_id: string, description: string, status?: string, asset_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "date",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Ledger date in YYYY-MM-DD format."
            },
            {
              "name": "amount",
              "type": "number",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Money or quantity amount in the selected asset."
            },
            {
              "name": "investment_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Investment account receiving or holding the security."
            },
            {
              "name": "source_account_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Source account id for funds, cash, or holdings."
            },
            {
              "name": "description",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable transaction, account, rule, or journal description."
            },
            {
              "name": "status",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "posted",
              "description": "Transaction status filter or value: posted, pending, planned, or void."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Records investment in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: date, amount, investment_account_id, source_account_id, description.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "date": "2026-06-01",
              "amount": 100,
              "investment_account_id": "<investment_account_id>",
              "source_account_id": "<source_account_id>",
              "description": "<description>"
            }
          }
        },
        {
          "name": "update_asset",
          "title": "Update Asset",
          "category": "Assets and investments",
          "summary": "Updates asset in the local Clovis ledger.",
          "signature": "(asset_id: string, symbol?: string | null, name?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            },
            {
              "name": "symbol",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "name",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Human-readable name to create or update."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Updates asset in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it for assets, prices, holdings, securities, investment activity, or foreign-exchange movement."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD"
            }
          }
        }
      ]
    },
    {
      "category": "Configuration",
      "tools": [
        {
          "name": "delete_tag",
          "title": "Delete Tag",
          "category": "Configuration",
          "summary": "Deletes tag in the local Clovis ledger.",
          "signature": "(tag_id: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tag_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Identifier from the local Clovis ledger."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Deletes tag in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: tag_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "tag_id": "<tag_id>"
            }
          }
        },
        {
          "name": "delete_tags",
          "title": "Delete Tags",
          "category": "Configuration",
          "summary": "Deletes tags in the local Clovis ledger.",
          "signature": "(entity_type: string, entity_id: string, key?: string | null, val?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "entity_type",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Entity id to filter reports when entity tracking is used."
            },
            {
              "name": "key",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "val",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Deletes tags in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: entity_type, entity_id.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "entity_type": "<entity_type>",
              "entity_id": "<entity_id>",
              "dry_run": true
            }
          }
        },
        {
          "name": "list_tags",
          "title": "List Tags",
          "category": "Configuration",
          "summary": "Lists tags in the local Clovis ledger.",
          "signature": "(entity_type: string, entity_id: string) => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [
            {
              "name": "entity_type",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            },
            {
              "name": "entity_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Entity id to filter reports when entity tracking is used."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists tags in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: entity_type, entity_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {
              "entity_type": "<entity_type>",
              "entity_id": "<entity_id>"
            }
          }
        },
        {
          "name": "operating_manual",
          "title": "Operating Manual",
          "category": "Configuration",
          "summary": "Returns Clovis operating guidance for agents and humans.",
          "signature": "(topic?: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "topic",
              "type": "string",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": "all",
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Returns Clovis operating guidance for agents and humans.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "tool_registry",
          "title": "Tool Registry",
          "category": "Configuration",
          "summary": "Returns the available public tools, signatures, and safety metadata.",
          "signature": "(names?: string[] | null, summary?: boolean, safety_filter?: string | null) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "names",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "summary",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Boolean switch for this workflow."
            },
            {
              "name": "safety_filter",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Returns the available public tools, signatures, and safety metadata.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        }
      ]
    },
    {
      "category": "Maintenance and safety",
      "tools": [
        {
          "name": "backup_now",
          "title": "Backup Now",
          "category": "Maintenance and safety",
          "summary": "Creates a local backup of the selected Clovis ledger.",
          "signature": "(output_path?: string | null, compact?: boolean, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "output_path",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Local output path for a generated file or backup."
            },
            {
              "name": "compact",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Returns a smaller response shape when true."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": false,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates a local backup of the selected Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it before or after risky operations to back up, inspect, or repair the ledger.",
              "Use it only for local files the user has intentionally made available to Clovis."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Confirm the file path, permissions, and whether the agent is allowed to read or write that location.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "backup_status",
          "title": "Backup Status",
          "category": "Maintenance and safety",
          "summary": "Shows backup configuration and recent backup state for the local ledger.",
          "signature": "() => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Shows backup configuration and recent backup state for the local ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it before or after risky operations to back up, inspect, or repair the ledger."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "integrity_check",
          "title": "Integrity Check",
          "category": "Maintenance and safety",
          "summary": "Checks the ledger for structural or accounting problems before an agent changes anything.",
          "signature": "() => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Checks the ledger for structural or accounting problems before an agent changes anything.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it before or after risky operations to back up, inspect, or repair the ledger."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "list_backups",
          "title": "List Backups",
          "category": "Maintenance and safety",
          "summary": "Lists backups in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists backups in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it before or after risky operations to back up, inspect, or repair the ledger."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "repair_integrity",
          "title": "Repair Integrity",
          "category": "Maintenance and safety",
          "summary": "Repairs integrity in the local Clovis ledger.",
          "signature": "(dry_run?: boolean, backup?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            },
            {
              "name": "backup",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Boolean switch for this workflow."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Repairs integrity in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it before or after risky operations to back up, inspect, or repair the ledger."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        }
      ]
    },
    {
      "category": "Scenarios",
      "tools": [
        {
          "name": "compare_scenarios",
          "title": "Compare Scenarios",
          "category": "Scenarios",
          "summary": "Compares scenarios in the local Clovis ledger.",
          "signature": "(as_of_a?: string | null, as_of_b?: string | null, asset_id: string) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "as_of_a",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "as_of_b",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Input used by this tool."
            },
            {
              "name": "asset_id",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Asset or currency id used by the ledger."
            }
          ],
          "aliases": {
            "asset": "asset_id"
          },
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Compares scenarios in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: asset_id."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "asset_id": "USD"
            }
          }
        },
        {
          "name": "create_branch",
          "title": "Create Branch",
          "category": "Scenarios",
          "summary": "Creates scenario branch in the local Clovis ledger.",
          "signature": "(name: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Creates scenario branch in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: name.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "name": "<name>"
            }
          }
        },
        {
          "name": "discard_batch",
          "title": "Discard Batch",
          "category": "Scenarios",
          "summary": "Discards batch in the local Clovis ledger.",
          "signature": "(tx_ids?: string[] | null, batch_id?: string | null, date_from?: string | null, date_to?: string | null, account_id?: string | null, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "tx_ids",
              "type": "string[]",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "List of transaction ids."
            },
            {
              "name": "batch_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Import, commit, or mutation batch id."
            },
            {
              "name": "date_from",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Start date filter in YYYY-MM-DD format."
            },
            {
              "name": "date_to",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "End date filter in YYYY-MM-DD format."
            },
            {
              "name": "account_id",
              "type": "string",
              "required": false,
              "nullable": true,
              "variadic": false,
              "default": null,
              "description": "Ledger account id or resolvable account reference."
            },
            {
              "name": "dry_run",
              "type": "boolean",
              "required": false,
              "nullable": false,
              "variadic": false,
              "default": true,
              "description": "Preview the result without committing changes."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": true,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": true
          },
          "docs": {
            "summary": "Discards batch in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "dry_run": true
            }
          }
        },
        {
          "name": "discard_branch",
          "title": "Discard Branch",
          "category": "Scenarios",
          "summary": "Discards scenario branch in the local Clovis ledger.",
          "signature": "(name: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "name",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Human-readable name to create or update."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": true,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": true,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Discards scenario branch in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: name.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "Create or confirm a backup and get explicit approval before running it for real."
            ],
            "safety": "Destructive. This can remove, void, discard, roll back, repair, or permanently change ledger data. Require explicit user approval.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "name": "<name>"
            }
          }
        },
        {
          "name": "list_branches",
          "title": "List Branches",
          "category": "Scenarios",
          "summary": "Lists scenario branches in the local Clovis ledger.",
          "signature": "() => Array<Record<string, unknown>>",
          "returns": {
            "type": "object[]"
          },
          "parameters": [],
          "aliases": {},
          "readOnly": true,
          "destructive": false,
          "dryRun": false,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": true,
            "destructiveHint": false,
            "idempotentHint": true,
            "openWorldHint": false,
            "supportsDryRun": false,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Lists scenario branches in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to inspect the ledger or answer a question without changing records.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "No required inputs are needed, but date, status, asset, and account filters should still be explicit when the user cares about scope."
            ],
            "safety": "Read-only. This is appropriate for inspection, reporting, diagnostics, and first-pass agent answers.",
            "returns": "Returns object[] from the local ledger.",
            "exampleArguments": {}
          }
        },
        {
          "name": "merge_branch",
          "title": "Merge Branch",
          "category": "Scenarios",
          "summary": "Merges scenario branch in the local Clovis ledger.",
          "signature": "(source: string, dry_run?: boolean) => Record<string, unknown>",
          "returns": {
            "type": "object"
          },
          "parameters": [
            {
              "name": "source",
              "type": "string",
              "required": true,
              "nullable": false,
              "variadic": false,
              "description": "Input used by this tool."
            }
          ],
          "aliases": {},
          "readOnly": false,
          "destructive": false,
          "dryRun": true,
          "defaultDryRun": false,
          "annotations": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false
          },
          "safety": {
            "readOnlyHint": false,
            "destructiveHint": false,
            "idempotentHint": false,
            "openWorldHint": false,
            "supportsDryRun": true,
            "defaultDryRun": false
          },
          "docs": {
            "summary": "Merges scenario branch in the local Clovis ledger.",
            "useWhen": [
              "Use it when an agent needs to prepare a change and show a preview before committing it.",
              "Use it when exploring or managing scenario branches separate from posted records."
            ],
            "beforeCalling": [
              "Have exact values for required inputs: source.",
              "Start with dry_run=true, show the preview, then ask before applying the change.",
              "State the intended ledger change in plain language before calling the tool."
            ],
            "safety": "Can write, but supports dry-run. Ask the agent to preview the result before committing changes.",
            "returns": "Returns object from the local ledger.",
            "exampleArguments": {
              "source": "<source>"
            }
          }
        }
      ]
    }
  ]
} as const;

export type ClovisDocs = typeof clovisDocs;
